export default {
  "nav": {
    "feed": "Flux",
    "map": "Carte",
    "discover": "Vibes",
    "plans": "Forfaits",
    "messages": "Discuter",
    "profile": "Profil"
  },
  "common": {
    "back": "Retour",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saving": "Enregistrement...",
    "edit": "Modifier",
    "delete": "Supprimer",
    "remove": "Retirer",
    "refresh": "Actualiser",
    "error": "Erreur",
    "loading": "Chargement...",
    "tryAgain": "Veuillez réessayer.",
    "clear": "Effacer",
    "enable": "Activer",
    "tapToRetry": "Appuyez pour réessayer",
    "somethingWentWrong": "Quelque chose s'est mal passé.",
    "comingSoon": "À VENIR",
    "send": "Envoyer",
    "ok": "OK",
    "gotIt": "Compris",
    "couldNotOpenLink": "Impossible d’ouvrir le lien.",
    "done": "Terminé",
    "retry": "Réessayer",
    "later": "Plus tard",
    "notNow": "Pas maintenant",
    "openSettings": "Ouvrir les réglages",
    "loadingTonyte": "Chargement de Tonyte…",
    "findingYourVibe": "Recherche de ton ambiance…",
    "almostThere": "On y est presque…",
    "stillGettingThingsReady": "Nous préparons encore tout…",
    "profileLoadErrorTitle": "Impossible de charger ton profil",
    "profileLoadErrorMessage": "Vérifie ta connexion et réessaie.",
    "continue": "Continuer",
    "unknown": "Inconnu",
    "unknownError": "Erreur inconnue.",
    "user": "utilisateur",
    "sharedOnTonyte": "{name} sur Tonyte"
  },
  "auth": {
    "signInRequired": "Connexion requise",
    "signInToUseFeature": "Connectez-vous pour utiliser cette fonctionnalité.",
    "emailAlreadyInUse": "Un compte existe déjà avec cet email. Connectez-vous plutôt.",
    "invalidEmail": "Saisissez une adresse e-mail valide.",
    "invalidCredentials": "L'e-mail ou le mot de passe est incorrect.",
    "weakPassword": "Utilisez un mot de passe d'au moins 6 caractères.",
    "methodNotEnabled": "Cette méthode de connexion n'est pas encore activée.",
    "networkError": "Erreur réseau. Vérifiez votre connexion et réessayez.",
    "signInFailed": "La connexion a échoué. Veuillez réessayer.",
    "notSignedIn": "Non connecté.",
    "googleSignInUnavailable": "Google Sign-In n'est pas disponible dans cette version. Reconstruisez l'application après avoir installé les dépendances natives.",
    "googleSignInCancelled": "La connexion à Google a été annulée.",
    "googleMissingIdToken": "La connexion à Google n'a pas renvoyé de jeton d'identification.",
    "appleSignInUnavailable": "La connexion Apple n'est pas disponible sur cet appareil.",
    "appleMissingIdentityToken": "La connexion Apple n'a pas renvoyé de jeton d'identité.",
    "appleSignInCancelled": "La connexion Apple a été annulée."
  },
  "verifyEmail": {
    "title": "Vérifiez votre e-mail",
    "subtitle": "Nous avons envoyé un lien de vérification à",
    "instructions": "Appuyez sur le lien dans cet e-mail, puis revenez ici et appuyez sur \"Vérifier à nouveau\".",
    "resend": "Renvoyer l'e-mail de vérification",
    "resendCooldown": "Renvoi disponible dans {count}s",
    "resendSuccess": "E-mail de vérification envoyé.",
    "resendFailure": "Impossible d'envoyer l'e-mail de vérification. Veuillez réessayer.",
    "resendRateLimited": "Veuillez patienter un instant avant de demander un autre e-mail.",
    "checkAgain": "Vérifier à nouveau",
    "checking": "Vérification…",
    "stillNotVerified": "Pas encore vérifié",
    "stillNotVerifiedMessage": "Nous ne trouvons toujours pas d'e-mail vérifié pour ce compte. Vérifiez votre boîte de réception (et le dossier spam), puis réessayez.",
    "verifiedSuccess": "E-mail vérifié ! Vous avez maintenant un accès complet.",
    "continueBrowsing": "Continuer à parcourir Événements & Carte",
    "logout": "Se déconnecter / changer de compte",
    "limitedAccessBanner": "Vérifiez votre e-mail pour débloquer Vibe, Plans, chat et plus.",
    "limitedAccessBannerAction": "Vérifier maintenant",
    "gateTitle": "Vérifiez d'abord votre e-mail",
    "gateMessage": "Cette fonctionnalité se débloque une fois votre adresse e-mail vérifiée.",
    "gateAction": "Vérifier maintenant"
  },
  "resetPassword": {
    "title": "Réinitialise ton mot de passe",
    "subtitle": "Choisis un nouveau mot de passe pour ton compte Tonyte.",
    "expiredLink": "Ce lien a expiré. Demande-en un nouveau depuis Tonyte.",
    "invalidLink": "Ce lien n’est pas valide ou a déjà été utilisé.",
    "weakPassword": "Utilise un mot de passe d’au moins 6 caractères.",
    "networkError": "Erreur réseau. Vérifie ta connexion et réessaie.",
    "verifyFailed": "Impossible de vérifier ce lien. Demande-en un nouveau.",
    "missingCode": "Le code de vérification manque dans ce lien.",
    "mismatch": "Les mots de passe ne correspondent pas.",
    "verifying": "Vérification du lien...",
    "updating": "Mise à jour du mot de passe...",
    "success": "Mot de passe mis à jour",
    "continueToLogin": "Continuer vers la connexion",
    "unavailable": "Lien indisponible",
    "resettingFor": "Réinitialisation du mot de passe de {email}",
    "newPassword": "Nouveau mot de passe",
    "minimumCharacters": "Au moins 6 caractères",
    "confirmPassword": "Confirmer le mot de passe",
    "enterAgain": "Saisis à nouveau le mot de passe",
    "updatePassword": "Mettre à jour le mot de passe"
  },
  "vibesList": {
    "eyebrow": "TES RENCONTRES",
    "title": "Vibes",
    "search": "Rechercher dans tes vibes",
    "noMatches": "Aucune vibe correspondante",
    "noMatchesSub": "Recherche par nom, identifiant, ville ou université.",
    "empty": "Pas encore de vibes",
    "emptySub": "Les personnes rencontrées via les chats et les vibes apparaîtront ici.",
    "openDailyVibes": "Ouvrir Daily Vibes",
    "removeTitle": "Supprimer cette vibe ?",
    "removeBody": "Cette personne sera retirée de tes Vibes, mais l’historique du chat sera conservé.",
    "removeFailed": "Impossible de supprimer cette vibe pour le moment.",
    "message": "Message",
    "viewProfile": "Voir le profil",
    "community": "Communauté Tonyte",
    "recentlyActive": "Actif récemment",
    "activeMinutes": "Actif il y a {count} min",
    "activeHours": "Actif il y a {count} h",
    "activeDays": "Actif il y a {count} j",
    "removeAccessibility": "Supprimer {name} des Vibes",
    "removeSuccess": "{name} a été retiré de tes Vibes"
  },
  "partner": {
    "profileSelectorTitle": "Choisissez un profil partenaire",
    "profileSelectorBody": "Ce compte gère plusieurs partenaires.",
    "profileUnavailableTitle": "Profil partenaire indisponible",
    "profileLoadFailed": "Nous n'avons pas pu vérifier votre accès partenaire. Réessayez sans perdre les données de votre compte.",
    "profileLinkMissing": "Votre compte partenaire est actif, mais aucun profil partenaire n'y est associé. Contactez le support Tonyte pour rétablir l'accès.",
    "publicProfileUnavailableBody": "Ce profil partenaire n'est pas disponible pour le moment.",
    "publicProfileLoadFailed": "Impossible de charger ce profil. Vérifiez votre connexion et réessayez.",
    "kicker": "Tonyte Partner",
    "tools": "Outils partenaires",
    "profile": "Profil partenaire",
    "profileSub": "Gère la présentation de ton entreprise sur Tonyte",
    "createEvent": "Créer un événement",
    "createEventSub": "Publier un nouvel événement",
    "myEvents": "Mes événements",
    "myEventsSub": "Voir, modifier ou supprimer tes événements à venir et en cours",
    "analytics": "Statistiques",
    "analyticsSub": "Ouvertures, marques d’intérêt et partages",
    "notifications": "Notifications",
    "notificationsSub": "Étapes et actualités de tes événements",
    "noNotifications": "Aucune notification pour le moment.",
    "totalTaps": "Ouvertures totales",
    "interestedTaps": "Intérêts",
    "shares": "Partages",
    "byEvent": "Par événement",
    "noAnalytics": "Aucun événement pour le moment — publie le premier pour voir ses statistiques.",
    "untitledEvent": "Événement sans titre",
    "taps": "ouvertures",
    "interested": "intéressés",
    "sharesLower": "partages",
    "createPassword": "Crée ton mot de passe",
    "firstSignIn": "C’est ta première connexion — définis un nouveau mot de passe pour continuer.",
    "setPasswordContinue": "Définir le mot de passe et continuer",
    "setPasswordFailed": "Impossible de définir le mot de passe. Réessaie.",
    "signOut": "Se déconnecter",
    "notAssigned": "Pas encore attribué",
    "categoryMissing": "Votre catégorie de partenaire n'a pas encore été attribuée. Contactez l'administrateur Tonyte pour configurer votre catégorie de compte.",
    "typeCommunity": "Communauté",
    "typeOrganizer": "Organisateur",
    "typeVenue": "Lieu",
    "typeUniversity": "Université",
    "typeStudentOrganization": "Organisation étudiante",
    "businessName": "Nom de l'entreprise",
    "description": "Descriptif",
    "descriptionPlaceholder": "Dites aux gens ce que vous faites",
    "website": "Site Web",
    "instagram": "Instagram",
    "venueAddress": "Adresse du lieu",
    "venueAddressPlaceholder": "Rue, ville, pays",
    "saveChanges": "Enregistrer les modifications",
    "viewTerms": "Afficher les conditions du partenaire",
    "requiredFields": "Le nom et la description de l'entreprise sont requis.",
    "venueAddressRequired": "Une adresse du lieu est requise.",
    "profileUpdated": "Profil mis à jour.",
    "profileSaveFailed": "Impossible d'enregistrer votre profil. Veuillez réessayer."
  },
  "editProfile": {
    "nameRequired": "Nom requis",
    "addName": "Ajoute un nom avant d’enregistrer ton profil.",
    "invalidDob": "Date de naissance invalide",
    "ageRequirement": "Tonyte est réservé aux personnes de {age} ans et plus. Vérifie ta date de naissance.",
    "saveFailed": "Impossible d’enregistrer le profil",
    "name": "Nom *",
    "yourName": "Ton nom",
    "bio": "Bio",
    "bioPlaceholder": "Parle un peu de toi à la communauté…",
    "city": "Ville",
    "yourCity": "Ta ville",
    "country": "Pays",
    "yourCountry": "Ton pays",
    "dateOfBirth": "Date de naissance",
    "personality": "Personnalité",
    "selectedCount": "{count}/30 sélectionnés",
    "addCustom": "Ajouter « {interest} »"
  },
  "waitingList": {
    "title": "Vous êtes sur la liste d'attente",
    "badge": "ACCÈS ANTICIPÉ",
    "headline": "Arrêtez de faire défiler.\nCommencez à sortir.",
    "supportingText": "Nous invitons progressivement de nouveaux membres pour garder la communauté authentique, active et sûre.",
    "featureEventsTitle": "Rechercher des événements",
    "featureEventsBody": "Découvrez ce qui se passe autour de vous.",
    "featurePlansTitle": "Créer des plans",
    "featurePlansBody": "Démarrez un plan et trouvez des personnes à rejoindre.",
    "featureVibeTitle": "Quotidien Vibe",
    "featureVibeBody": "Répondez à quelques questions et découvrez vos correspondances vibe.",
    "featureTogetherTitle": "Ne vous sentez jamais seul",
    "featureTogetherBody": "Trouvez toujours quelque chose à faire et quelqu'un avec qui le faire.",
    "applicationReceived": "Demande reçue",
    "notificationText": "Nous vous informerons dès que votre compte sera activé.",
    "currentCity": "Ville actuelle",
    "footer": "Merci de nous aider à construire l'avenir de la découverte sociale.",
    "visitWebsite": "Visiter le site Web",
    "visitWebsiteSub": "Découvrez comment fonctionne Tonyte →"
  },
  "login": {
    "missingDetails": "Détails manquants",
    "enterEmailPassword": "Saisissez votre email et votre mot de passe.",
    "passwordTooShort": "Mot de passe trop court",
    "passwordMin": "Utilisez au moins 6 caractères.",
    "emailSignInFailed": "Échec de l'authentification par courrier électronique",
    "emailRequired": "E-mail requis",
    "enterResetEmail": "Saisissez votre adresse e-mail pour réinitialiser votre mot de passe.",
    "forgotPassword": "Mot de passe oublié ?",
    "resetEmailSent": "Réinitialiser l'e-mail envoyé",
    "resetEmailSentMessage": "Vérifiez votre boîte de réception pour trouver un lien permettant de réinitialiser votre mot de passe.",
    "passwordResetFailed": "Échec de la réinitialisation du mot de passe",
    "signInFailed": "Échec de la connexion",
    "appleSignInFailed": "Échec de la connexion Apple",
    "signInWithEmail": "Connectez-vous avec votre e-mail",
    "createYourAccount": "Créez votre compte",
    "signIn": "Connectez-vous",
    "create": "S'inscrire",
    "createAccount": "Créer un compte",
    "email": "E-mail",
    "password": "Mot de passe",
    "findYour": "Trouvez votre",
    "people": "personnes",
    "plans": "plans",
    "tagline": "Arrêtez de faire défiler.\nCommencez à sortir.",
    "featurePeople": "Trouvez vos collaborateurs",
    "featureEvents": "Voir ce qui se passe",
    "featureAlone": "Ne sors jamais seul",
    "continueWithEmail": "Continuer avec l'e-mail",
    "continueWithGoogle": "Continuer avec Google",
    "continueWithApple": "Continuer avec Apple",
    "legalPrefix": "En continuant, vous acceptez nos",
    "and": "et",
    "partnerSignInHint": "Vous êtes partenaire Tonyte ? Connectez-vous ci-dessus avec votre identifiant partenaire ou votre e-mail"
  },
  "settings": {
    "title": "Paramètres",
    "account": "Compte",
    "appearance": "Apparence",
    "midnight": "Midnight",
    "daylight": "Daylight",
    "language": "Langue",
    "appLanguage": "Langue de l'application",
    "languageSaved": "Langue enregistrée",
    "languageSaveError": "Impossible d'enregistrer la langue.",
    "profileManagement": "Gestion des profils",
    "profileCompleted": "Profil complété",
    "profileCompletedSub": "Les réponses de votre profil sont entièrement définies.",
    "editProfile": "Modifier le profil",
    "editProfileAnswers": "Modifier les réponses du profil",
    "completeProfile": "Profil complet",
    "notifications": "Notifications",
    "pushNotifications": "Notifications poussées",
    "legal": "Mentions légales",
    "privacyPolicy": "Politique de confidentialité",
    "termsOfService": "Conditions d'utilisation",
    "communityGuidelines": "Règlement de la communauté",
    "impressum": "Mentions légales",
    "partnerTerms": "Conditions du partenaire",
    "dataDeletionRequest": "Demande de suppression de données",
    "about": "À propos",
    "tagline": "Rencontrer des gens. Live la nuit.",
    "accountPrivacy": "Confidentialité du compte",
    "blockedAccounts": "Comptes bloqués",
    "faq": "FAQ",
    "helpFeedback": "Aide et commentaires",
    "verificationCenter": "Centre de vérification",
    "savedTemplates": "Modèles enregistrés",
    "uploadedPlans": "Plans téléchargés",
    "adminControls": "Contrôles d'administration",
    "dataDeletion": "Suppression de données",
    "logout": "Déconnexion",
    "deleteAccount": "Supprimer le compte",
    "studentVerification": "Vérification de l'étudiant",
    "vibeVerification": "Obtenez la vérification Vibe",
    "tonyteSettings": "Paramètres Tonyte",
    "version": "Version {version}",
    "search": "Paramètres de recherche",
    "clearSearch": "Effacer la recherche des paramètres",
    "profile": "Profil",
    "partnerDashboard": "Tableau de bord des partenaires",
    "preferences": "Préférences",
    "privacyLegal": "Confidentialité et mentions légales",
    "support": "Prise en charge",
    "session": "Séance",
    "noSettings": "Aucun paramètre trouvé",
    "noSettingsSub": "Essayez un autre mot-clé.",
    "connectedEmail": "E-mail connecté",
    "noEmail": "Aucun email connecté",
    "signInMethod": "Méthode de connexion",
    "noSignInMethod": "Aucune méthode de connexion trouvée.",
    "passwordLogin": "Connexion par mot de passe activée",
    "connected": "{provider} connecté",
    "sendReset": "Envoyer la réinitialisation du mot de passe",
    "sending": "Envoi...",
    "unblock": "Débloquer",
    "noBlocked": "Aucun compte bloqué.",
    "searchFaq": "FAQ de recherche",
    "feedbackPlaceholder": "Dites-nous ce que vous pensez...",
    "feedbackEmail": "E-mail de contact (facultatif)",
    "sendFeedback": "Envoyer des commentaires",
    "chatNotifications": "Messages et Vibes",
    "eventNotifications": "Plans",
    "eventRecommendationNotifications": "Événements et recommandations",
    "partnerNotifications": "Partenaires suivis",
    "verifiedStudent": "Étudiant vérifié",
    "verifiedStudentSub": "Vous avez un accès complet aux événements réservés aux étudiants. Votre email d’étudiant reste privé.",
    "checkInbox": "Vérifiez votre boîte de réception",
    "verificationSentPrefix": "Nous avons envoyé un lien de vérification à",
    "verificationSentSuffix": "Cliquez sur le lien contenu dans cet e-mail pour confirmer la propriété.",
    "linkExpiry": "Le lien expire dans 24 heures. Vérifiez votre dossier spam si vous ne le voyez pas.",
    "wrongEmail": "Mauvaise adresse e-mail ?",
    "differentUniversityEmail": "Entrez une autre adresse e-mail universitaire",
    "resendVerification": "Renvoyer l'e-mail de vérification",
    "pendingReview": "En attente de révision",
    "pendingReviewSub": "La propriété de votre adresse e-mail a été confirmée. Un administrateur examinera votre établissement sous peu. Vous aurez accès une fois approuvé.",
    "verificationFailed": "Échec de la vérification",
    "studentFailedSub": "Votre vérification n'a pas été approuvée. Veuillez réessayer avec une adresse e-mail universitaire valide.",
    "universityEmail": "Courriel université/étudiant",
    "universityEmailHelp": "Saisissez l'e-mail de votre université. Nous vous enverrons un lien de vérification. Les institutions connues sont agréées instantanément ; d'autres sont examinés dans les 24 heures.",
    "sendVerification": "Envoyer un e-mail de vérification",
    "vibeVerifiedTitle": "Vibe Vérifié",
    "vibeVerifiedSub": "Votre profil possède le badge. Les autres utilisateurs voient la confiance, pas votre selfie.",
    "privacy": "Confidentialité",
    "verificationPrivacy": "Votre selfie de vérification est examiné manuellement et supprimé une fois la décision de vérification terminée. Le support de vérification est utilisé uniquement à des fins d’examen manuel — Tonyte n’utilise pas la reconnaissance faciale, l’analyse biométrique ou la vérification automatisée.",
    "verificationPending": "Vérification en attente",
    "verificationPendingSub": "Votre selfie est dans la file d'attente de révision. Vous obtiendrez le badge Vibe Verified après approbation.",
    "submittingSelfie": "Soumission de votre selfie…",
    "pendingAdminSub": "Votre demande restera en attente jusqu'à ce qu'un administrateur l'examine.",
    "selfieFailedSub": "Reprenez le selfie avec un bon éclairage, votre visage visible et le geste dans le cadre.",
    "tryAgain": "Réessayez",
    "reviewSelfie": "Révisez votre selfie",
    "reviewSelfieSub": "Assurez-vous que votre visage et vos gestes sont clairs avant de soumettre.",
    "retake": "Reprendre",
    "submitReview": "Soumettre pour révision",
    "getVerified": "Obtenez la vérification Vibe",
    "getVerifiedSub": "Prenez un selfie rapide pour montrer que vous êtes une vraie personne et établir un climat de confiance avec les autres. Votre selfie de vérification est examiné manuellement et supprimé une fois la décision de vérification prise.",
    "examplePose": "Exemple de pose",
    "matchPose": "Prenez un selfie correspondant à la pose ci-dessus.",
    "faceVisible": "Visage bien visible",
    "gestureVisible": "Geste de la main visible",
    "goodLighting": "Bon éclairage",
    "noFilters": "Aucun filtre ni capture d'écran",
    "takeVerificationSelfie": "Prendre un selfie de vérification",
    "deleteAccountTitle": "Supprimer le compte",
    "deleteAccountConfirm": "Êtes-vous sûr de vouloir supprimer définitivement votre compte Tonyte ? Cette action ne peut pas être annulée.",
    "deleteProfileInfo": "Votre profil ne sera plus visible.",
    "deleteDataInfo": "Vos discussions privées, correspondances, blocages, balayages et données de compte seront supprimés.",
    "deletePlansInfo": "Vos plans communautaires seront supprimés. Les événements publics ne sont pas supprimés par cette action.",
    "confirmIdentity": "Confirmez qu'il s'agit bien de vous",
    "reauthenticate": "Pour des raisons de sécurité, veuillez vous réauthentifier auprès de {provider} avant de supprimer votre compte.",
    "enterPassword": "Entrez votre mot de passe",
    "loadingUsers": "Chargement des utilisateurs…",
    "totalUsers": "Nombre total d'utilisateurs {count}",
    "searchUsers": "Rechercher des utilisateurs...",
    "noEmailAvailable": "Aucun e-mail disponible",
    "protectedAccount": "Compte protégé",
    "revoking": "Révoquer…",
    "revokeVerified": "Révoquer Vibe vérifié",
    "suspendAccountAction": "Suspendre",
    "unsuspendAccountAction": "Réactiver",
    "suspending": "Mise à jour…",
    "suspendAccountTitle": "Suspendre le compte",
    "unsuspendAccountTitle": "Réactiver le compte",
    "suspendAccountConfirm": "Suspendre le compte de {name} ? Il sera déconnecté et ne pourra pas se reconnecter tant qu'il n'est pas réactivé.",
    "unsuspendAccountConfirm": "Réactiver le compte de {name} ? Il pourra se reconnecter.",
    "suspendAccountSuccess": "{name} a été suspendu.",
    "unsuspendAccountSuccess": "{name} a été réactivé.",
    "suspendAccountFailed": "Impossible de suspendre ce compte. Veuillez réessayer.",
    "unsuspendAccountFailed": "Impossible de réactiver ce compte. Veuillez réessayer.",
    "cannotSuspendSelf": "Vous ne pouvez pas suspendre votre propre compte.",
    "deleteAccountAction": "Supprimer le compte",
    "deletingAccount": "Suppression…",
    "deleteAccountTitle": "Supprimer le compte",
    "deleteAccountConfirm1": "Supprimer définitivement {name} ({email}) ? Cela supprimera son compte de façon permanente et ne peut pas être annulé.",
    "deleteAccountFinalTitle": "Êtes-vous absolument certain ?",
    "deleteAccountFinalBody": "Cela supprime définitivement le compte de Firebase Authentication et de Tonyte. Cette action ne peut pas être annulée.",
    "deleteAccountFinalAction": "Supprimer définitivement",
    "deleteAccountSuccess": "{name} a été définitivement supprimé.",
    "deleteAccountFailed": "Impossible de supprimer ce compte. Veuillez réessayer.",
    "cannotDeleteSelf": "Vous ne pouvez pas supprimer votre propre compte.",
    "cannotDeleteAdmin": "Les administrateurs ne peuvent pas supprimer d'autres comptes administrateur.",
    "noUsers": "Aucun utilisateur trouvé",
    "noPendingRequests": "Aucune demande en attente",
    "requestedEmail": "E-mail demandé",
    "domain": "Domaine",
    "requested": "Demandé",
    "emailOwnership": "Propriété de l'e-mail",
    "confirmed": "Confirmé",
    "notConfirmed": "Non confirmé",
    "accept": "Accepter",
    "noPendingFace": "Aucune demande de visage en attente",
    "noAccountEmail": "Aucune adresse e-mail de compte",
    "shakaSelfie": "Selfie de Shaka",
    "posePassLabel": "Pose",
    "livenessPassLabel": "Liveness",
    "front": "Avant",
    "left": "Gauche",
    "right": "Droite",
    "approve": "Approuver",
    "reject": "Rejeter",
    "eventCity": "Ville de l'événement",
    "eventCityHelp": "Modifie votre ville de flux et de carte."
  },
  "chat": {
    "title": "Discuter",
    "subtitle": "Chats, requêtes vibe et envois vibes",
    "chats": "Discussions",
    "vibeRequests": "Requêtes Vibe",
    "sentVibes": "Envoyé Vibes",
    "searchChats": "Rechercher des discussions",
    "noMessages": "Aucun message pour l'instant",
    "noChatsFound": "Aucune discussion trouvée",
    "noChatsYet": "Pas encore de discussion",
    "tryDifferentKeyword": "Essayez un autre nom ou mot-clé.",
    "chatsAppearHere": "Vos discussions apparaîtront ici",
    "joinToStart": "Rejoignez un événement ou envoyez un vibe pour commencer à discuter.",
    "signInToUseVibes": "Connectez-vous pour utiliser vibes",
    "signInSub": "Créez un compte pour afficher les requêtes vibe et les discussions privées.",
    "translateChat": "Traduire le chat",
    "translatingChat": "Traduction...",
    "showOriginal": "Afficher l'original",
    "translationFailed": "Impossible de traduire le chat.",
    "chatUnmuted": "Chat activé",
    "chatMuted": "Chat désactivé",
    "leftChat": "Vous avez quitté le chat",
    "blockUserQuestion": "Bloquer l'utilisateur ?",
    "blockUserMessage": "Vous ne verrez plus les messages de {name}. Le blocage est à sens unique et ne les avertira pas.",
    "thisUser": "cet utilisateur",
    "block": "Bloquer",
    "userBlocked": "Utilisateur bloqué",
    "couldNotBlockUser": "Impossible de bloquer l'utilisateur",
    "deleteChatQuestion": "Supprimer le chat ?",
    "deleteChatMessage": "Ce chat sera définitivement supprimé et ne pourra pas être annulé.",
    "chatDeleted": "Chat supprimé",
    "couldNotDeleteChat": "Impossible de supprimer le chat",
    "deletePlanMessage": "Cela supprimera définitivement le plan et son chat pour tous les participants.",
    "vibePromptsReady": "Vos invites de synchronisation vibe sont prêtes",
    "you": "Vous",
    "traveler": "Membre Tonyte",
    "tonyteEvent": "ÉVÉNEMENT TONYTE",
    "openEvent": "Événement ouvert",
    "directMessage": "Message direct",
    "youBlockedUser": "Vous avez bloqué cet utilisateur",
    "unblockInSettings": "Débloquez-les des paramètres de profil pour revoir ce chat.",
    "vibeEnded": "Ce Vibe a pris fin",
    "vibeEndedBody": "Cette connexion et son historique de discussion n'existent plus. Envoyez une nouvelle demande de Vibe pour vous reconnecter.",
    "eventChatEnded": "Cet événement est terminé",
    "planChatEnded": "Ce plan est terminé",
    "removeFromPlan": "Retirer du plan",
    "removeFromPlanQuestion": "Retirer {name} de ce plan ?",
    "removeFromPlanMessage": "Cette personne perdra l'accès au chat du plan et n'en fera plus partie.",
    "removedFromPlan": "Vous avez été retiré(e) de ce plan.",
    "memberRemoved": "Membre retiré",
    "couldNotRemoveMember": "Impossible de retirer ce membre. Veuillez réessayer.",
    "typeMessage": "Saisissez un message...",
    "couldNotSendImage": "Impossible d'envoyer l'image.",
    "locationUnavailable": "Emplacement indisponible.",
    "couldNotSendLocation": "Impossible d’envoyer la position.",
    "sharedLocationLabel": "Position partagée",
    "viewOnMap": "Voir sur la carte",
    "invalidSharedLocation": "Cette position ne peut pas être ouverte pour le moment.",
    "eventExpiredLabel": "EXPIRÉ",
    "eventExpired": "Événement expiré",
    "eventExpiredToast": "Cet événement n’est plus disponible.",
    "microphoneNowEnabled": "Accès au microphone activé",
    "reply": "Répondre",
    "gifs": "GIFS",
    "gifSearchResults": "Résultats",
    "gifTrendingNow": "Tendances",
    "searchGiphy": "Rechercher sur GIPHY",
    "recentlyUsed": "Utilisés récemment",
    "gifsLoadFailed": "Impossible de charger les GIF. Vérifie ta connexion et réessaie.",
    "microphoneAccessNeeded": "Accès au micro requis",
    "microphoneAccessMessage": "Tonyte a besoin du micro pour envoyer des messages vocaux. Active-le dans les réglages pour continuer.",
    "recordingUnavailable": "Enregistrement indisponible",
    "recordingUnavailableMessage": "Impossible de démarrer l’enregistrement. Réessaie.",
    "wantsToVibe": "Veut vibe avec vous",
    "status": "Statut : {status}",
    "accepted": "Accepté",
    "passed": "Réussi",
    "pending": "En attente",
    "profileSource": "Profil Tonyte",
    "sharedPlan": "Forfait partagé",
    "sharedEvent": "Événement partagé",
    "noRequestMessage": "Aucun message ajouté pour l'instant.",
    "vibe": "Vibe",
    "pass": "Réussir",
    "alreadyVibing": "Déjà vibrant",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "vibeVerified": "Vibe Vérifié",
    "bio": "Biographie",
    "interests": "Intérêts",
    "requestMessage": "Message de demande",
    "viewProfile": "Afficher le profil",
    "working": "Travail...",
    "cancelRequest": "Annuler la demande",
    "peopleHere": "GENS ICI",
    "connectTravelers": "Trouvez vos gens",
    "loadingTravelers": "Chargement des personnes...",
    "tryAgain": "Réessayez",
    "noTravelers": "Personne d'autre ici pour l'instant.",
    "noTravelersSub": "Soyez le premier à ouvrir People Here et votre carte apparaîtra aux autres.",
    "vibing": "Vibreur",
    "sent": "Envoyé",
    "accept": "Accepter",
    "sendVibe": "Envoyer un vibe",
    "sendVibeSub": "Ajoutez une courte note pour {name}. Vous pouvez également l'envoyer vierge.",
    "optionalMessage": "Message facultatif...",
    "sending": "Envoi...",
    "sendVibeAction": "Envoyer Vibe",
    "planChat": "PLANIFIER UNE CHATTE",
    "eventChat": "CHAT D'ÉVÉNEMENT",
    "communityPlan": "Plan communautaire",
    "officialEvent": "Événement officiel",
    "vibingWith": "Vibrer avec",
    "groupCount": "{count} {people} dans ce chat {kind}",
    "person": "personne",
    "people": "personnes",
    "plan": "régime\névénement",
    "event": "",
    "loadingMembers": "Chargement des membres...",
    "openProfiles": "Ouvrir les profils et envoyer vibes",
    "deleteChat": "Supprimer le chat",
    "leaveChat": "Quitter le chat",
    "adminCannotLeave": "Les administrateurs du plan ne peuvent pas quitter le chat. Supprimer ce plan à la place ?",
    "noStay": "Non, reste",
    "yesDeletePlan": "Oui, supprimer le plan",
    "leavePlanConfirm": "Quitter ce plan de discussion ? Vous pouvez vous réinscrire à partir de la page du plan.",
    "leaveEventConfirm": "Quitter le chat de cet événement ?",
    "leaving": "Départ…",
    "leave": "Congé",
    "safety": "SÉCURITÉ",
    "reportPerson": "Rapport {name}",
    "chooseReason": "Choisissez d'abord une raison.",
    "reportFailed": "Échec du rapport. Veuillez réessayer.",
    "optionalDetails": "Détails facultatifs…",
    "submitReport": "Soumettre le rapport",
    "reportUser": "Signaler l'utilisateur",
    "blockUser": "Bloquer l'utilisateur",
    "viewProfileTitle": "Afficher le profil",
    "muteChat": "Chat muet",
    "unmuteChat": "Activer le chat",
    "loadingRequests": "Chargement des requêtes...",
    "noPendingRequests": "Aucune demande vibe en attente",
    "pendingRequestsSub": "Les demandes reçues apparaîtront ici avant d'être déplacées vers Chats.",
    "loadingSent": "Chargement envoyé vibes...",
    "noSent": "Aucun vibes envoyé pour l'instant",
    "noSentSub": "Vibes que vous envoyez depuis People Here sera suivi ici.",
    "reasonSpam": "Pourriel",
    "reasonHarassment": "Harcèlement",
    "reasonFake": "Faux profil",
    "reasonContent": "Contenu inapproprié",
    "reasonScam": "Arnaque ou comportement dangereux",
    "reasonOther": "Autre",
    "tonyteVenue": "LIEU TONYTE",
    "newMessage": "Nouveau message",
    "newMessageFallback": "Vous avez reçu un nouveau message.",
    "someone": "Quelqu'un",
    "requestAcceptFailed": "Impossible d'accepter la demande. Veuillez réessayer.",
    "requestDeclineFailed": "Impossible de refuser la demande. Veuillez réessayer.",
    "requestCancelFailed": "Impossible d'annuler la demande. Veuillez réessayer.",
    "travelersLoadFailed": "Impossible de charger les personnes. Veuillez réessayer.",
    "signInSendVibes": "Connectez-vous pour envoyer des requêtes vibe.",
    "vibeRequestSendFailed": "Impossible d'envoyer la requête vibe. Veuillez réessayer.",
    "nowVibingWith": "Vous vibrez désormais avec {name} !",
    "leaveFailed": "Impossible de quitter le chat. Veuillez réessayer.",
    "requestPassed": "Demande réussie",
    "gifSendFailed": "Impossible d'envoyer le GIF. Essayer à nouveau.",
    "voiceUploadFailed": "Le téléchargement de la note vocale a échoué. Appuyez sur réessayer dans le message.",
    "reportSubmitted": "Rapport soumis",
    "now": "maintenant",
    "minutesShort": "{count}m",
    "hoursShort": "{count}h",
    "daysShort": "{count}d",
    "vibingCount_one": "{count} personne qui vibe",
    "vibingCount_few": "{count} personnes qui vibent",
    "vibingCount_many": "{count} personnes qui vibent",
    "vibingCount_other": "{count} personnes qui vibent",
    "memberJoined": "{name} a rejoint le chat",
    "memberLeft": "{name} a quitté le chat",
    "lastSeenJustNow": "Vu pour la dernière fois à l'instant",
    "lastSeenMinutes_one": "Vu pour la dernière fois il y a {count} min",
    "lastSeenMinutes_few": "Vu pour la dernière fois il y a {count} min",
    "lastSeenMinutes_many": "Vu pour la dernière fois il y a {count} min",
    "lastSeenMinutes_other": "Vu pour la dernière fois il y a {count} min",
    "lastSeenHours_one": "Vu pour la dernière fois il y a {count}h",
    "lastSeenHours_few": "Vu pour la dernière fois il y a {count}h",
    "lastSeenHours_many": "Vu pour la dernière fois il y a {count}h",
    "lastSeenHours_other": "Vu pour la dernière fois il y a {count}h",
    "lastSeenYesterday": "Vu pour la dernière fois hier",
    "lastSeenDays_one": "Vu pour la dernière fois il y a {count}d",
    "lastSeenDays_few": "Vu pour la dernière fois il y a {count}d",
    "lastSeenDays_many": "Vu pour la dernière fois il y a {count}d",
    "lastSeenDays_other": "Vu pour la dernière fois il y a {count}d",
    "lastSeenAWhileAgo": "Vu pour la dernière fois il y a quelque temps",
    "seen": "Vu",
    "seenJustNow": "Vu à l'instant",
    "seenMinutes_one": "Vu il y a {count} min",
    "seenMinutes_few": "Vu il y a {count} min",
    "seenMinutes_many": "Vu il y a {count} min",
    "seenMinutes_other": "Vu il y a {count} min",
    "seenHours_one": "Vu il y a {count}h",
    "seenHours_few": "Vu il y a {count}h",
    "seenHours_many": "Vu il y a {count}h",
    "seenHours_other": "Vu il y a {count}h",
    "yesterday": "Hier",
    "typing": "Saisie...",
    "online": "En ligne",
    "studiZonePlan": "Plan StudiZone"
  },
  "discover": {
    "heroTitle": "Vibes",
    "vibesSubtitle": "Des gens. Des lieux. Le campus.",
    "findMyVibeTitle": "Trouver mon vibe",
    "findMyVibeDesc": "Joue au quiz. Rencontre ta tribu.",
    "venuesCardDesc": "Profils partenaires.",
    "studiZoneCardDesc": "Communauté du campus.",
    "statusOpensAt": "Ouvre à {time}",
    "statusResultsAt": "Résultats {time}",
    "statusResultsOut": "Résultats dispo",
    "studiZoneVerifiedOnly": "Étudiants vérifiés",
    "infoPill": "Répondez à quelques questions. Obtenez votre vibe. Trouvez votre peuple.",
    "addPhotoLocked": "Ajoutez une vraie photo de profil avant d'utiliser la découverte sociale.",
    "daySubtitle": "Répondez au vibe check du jour",
    "dayDescription": "Répondez à quelques questions quotidiennes pour révéler votre aura, débloquez votre Vibe Circle et rencontrez des personnes sur la même longueur d’onde.",
    "venueSubtitle": "Découvrez qui fait vibrer votre ville",
    "venueDescription": "Explorez les lieux, artistes, communautés et organisateurs locaux. Suivez vos favoris et découvrez leurs événements, actualités et calendriers.",
    "studiZoneTitle": "StudiZone",
    "studiZoneSubtitle": "Votre espace étudiant vérifié",
    "studiZoneDescription": "Découvrez les événements du campus, les plans, les communautés et les discussions entre étudiants vérifiés.",
    "studiZoneButton": "Entrer dans StudiZone ->",
    "letsGo": "C'est parti ->",
    "citySync": "Synchronisation de la ville",
    "tonightSync": "Synchronisation ce soir",
    "auraLockedText": "Nouveau ici ? Ne vous inquiétez pas.\nL'analyse aura d'aujourd'hui ouvre à 6h00 AM.",
    "auraQuestionsText": "Répondez aux questions.\nTrouvez votre aura et débloquez votre cercle Vibe.",
    "auraResultsText": "Résultats.\nTrouvez votre aura et avec qui vous êtes vibe aujourd'hui.",
    "auraOpenTime": "6h00",
    "auraResultsTime": "1h00",
    "am": "AM",
    "pm": "PM",
    "live": "LIVE",
    "now": "MAINTENANT",
    "underConstruction": "En construction",
    "venueTesterUnavailable": "Vibe sur Venues est en cours de préparation pour un accès anticipé. Aura Vibe reste disponible."
  },
  "feedFilters": {
    "now": "Maintenant",
    "tonight": "Ce soir",
    "parties": "Parties",
    "social": "Social",
    "nearby": "À proximité",
    "high-energy": "Haute énergie",
    "food": "Nourriture",
    "activities": "Activités",
    "chill": "Refroidissement",
    "date-idea": "Idée de rendez-vous",
    "solo-friendly": "Solo Amical",
    "student": "Étudiant",
    "free": "Gratuit"
  },
  "interests": {
    "addInterests": "Ajouter des centres d'intérêt",
    "selectedInterests": "Centres d'intérêt sélectionnés",
    "selected": "sélectionné",
    "searchInterests": "Centres d'intérêt de recherche",
    "add": "Ajouter",
    "saveInterests": "Enregistrer les centres d'intérêt",
    "categories": {
      "travel": "Voyage",
      "food_and_drinks": "Nourriture et boissons",
      "nightlife": "Vie nocturne",
      "sports_and_fitness": "Sports et remise en forme",
      "music": "Musique",
      "art_and_creativity": "Art et créativité",
      "social_and_culture": "Social et culturel",
      "tech_and_gaming": "Technologie et jeux",
      "outdoors": "À l'extérieur",
      "relax_and_lifestyle": "Détente et style de vie"
    },
    "items": {
      "backpacking": "Randonnée",
      "road_trips": "Voyages en voiture",
      "solo_travel": "Voyage en solo",
      "luxury_travel": "Voyage de luxe",
      "digital_nomad": "Nomade numérique",
      "adventure_travel": "Voyage d'aventure",
      "city_exploration": "Exploration de la ville",
      "beach_trips": "Voyages à la plage",
      "mountains": "Montagnes",
      "camping": "Camping",
      "street_food": "Cuisine de rue",
      "fine_dining": "Gastronomie",
      "cafes": "Cafés",
      "bars": "Barres",
      "cocktails": "Cocktails",
      "wine_tasting": "Dégustation de vins",
      "beer": "Bière",
      "cooking": "Cuisine",
      "vegan_food": "Nourriture végétalienne",
      "desserts": "Desserts",
      "clubbing": "Clubbing",
      "house_music": "Musique House",
      "techno": "Techno",
      "hip_hop": "Hip-Hop",
      "live_djs": "DJ Live",
      "pub_crawls": "Tournées des pubs",
      "after_parties": "Après les fêtes",
      "festivals": "Fêtes",
      "dance": "Danse",
      "karaoke": "Karaoké",
      "gym": "Salle de sport",
      "running": "En cours d'exécution",
      "football": "Foot",
      "basketball": "Basket-ball",
      "yoga": "Yoga",
      "hiking": "Randonnée",
      "cycling": "Cyclisme",
      "swimming": "Natation",
      "martial_arts": "Arts martiaux",
      "crossfit": "CrossFit",
      "rap": "Rap",
      "pop": "Pop",
      "rock": "Rocher",
      "edm": "EDM",
      "jazz": "Jazz",
      "classical": "Classique",
      "indie": "Indépendant",
      "lo_fi": "Lo-Fi",
      "live_concerts": "Concerts Live",
      "singing": "Chant",
      "photography": "Photographie",
      "painting": "Peinture",
      "graphic_design": "Conception graphique",
      "illustration": "Illustration",
      "3d_art": "Art 3D",
      "videography": "Vidéographie",
      "content_creation": "Création de contenu",
      "fashion": "Mode",
      "tattoo_art": "Tatouage",
      "animation": "Animations",
      "meeting_people": "Rencontrer des gens",
      "languages": "Langues",
      "cultural_exchange": "Échange culturel",
      "volunteering": "Bénévolat",
      "networking": "Réseau",
      "events": "Événements",
      "public_speaking": "Prise de parole en public",
      "debates": "Débats",
      "history": "Historique",
      "museums": "Musées",
      "gaming": "Jeux",
      "pc_gaming": "Jeux sur PC",
      "console_gaming": "Jeux sur console",
      "ai": "IA",
      "startups": "Startups",
      "coding": "Codage",
      "cybersecurity": "Cybersécurité",
      "web3": "Web3",
      "gadgets": "Gadgets",
      "esports": "E-sport",
      "nature": "Nature",
      "sunsets": "Couchers de soleil",
      "photography_walks": "Balades photographiques",
      "picnics": "Pique-niques",
      "fishing": "Pêche",
      "climbing": "Escalade",
      "kayaking": "Kayak",
      "skiing": "Ski",
      "snowboarding": "Snowboard",
      "wildlife": "Faune",
      "netflix": "Netflix",
      "reading": "Lecture",
      "meditation": "Méditation",
      "spa": "Spa",
      "journaling": "Journalisation",
      "podcasts": "Baladodiffusions",
      "shopping": "Achats",
      "minimalism": "Minimalisme",
      "self_growth": "Croissance personnelle",
      "coffee": "Café"
    }
  },
  "feed": {
    "free": "Gratuit",
    "freeEntry": "Entrée gratuite",
    "paidEntry": "Entrée payante",
    "ongoing": "En cours",
    "nowOn": "Maintenant",
    "runsUntil": "S'exécute jusqu'à",
    "until": "jusqu'à",
    "peopleGoing": "personnes participent",
    "peopleGoingCount_one": "{count} personne participe",
    "peopleGoingCount_few": "{count} personnes participent",
    "peopleGoingCount_many": "{count} personnes participent",
    "peopleGoingCount_other": "{count} personnes participent",
    "tonyteVenue": "Lieu Tonyte",
    "ticketsFrom": "Billets de",
    "eyebrow": "Événements officiels et événements organisés à proximité",
    "whatsOnIn": "Quoi de neuf dans",
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "date": "Date",
    "gettingLocation": "Obtenir votre position...",
    "locationDenied": "Accès à la localisation refusé. Activez-le dans Paramètres pour voir les événements à proximité.",
    "enableLocation": "Activer la localisation pour voir les événements à proximité.",
    "featuredThisWeek": "À la une cette semaine",
    "topPicksForYou": "Sélection pour vous",
    "popularNearYou": "Populaires près de chez vous",
    "topPicksError": "Impossible de charger vos suggestions.",
    "topPicksSubtitle": "Événements qui correspondent à vos centres d’intérêt",
    "topPicksSubtitlePopular": "Événements tendance près de chez vous",
    "topPicksSeeAll": "Tout voir",
    "topPicksBadge": "Pour vous",
    "topPicksEyebrow": "Recommandé pour vous",
    "topPicksReason": {
      "interest": "Parce que vous aimez {interest}",
      "category": "Correspond à vos centres d’intérêt {category}",
      "joined": "Similaire aux événements que vous avez rejoints",
      "shared": "Similaire aux événements que vous avez partagés",
      "viewed": "Basé sur les événements que vous avez consultés"
    },
    "allEvents": "Tous les événements",
    "searchPlaceholder": "Trouve ta prochaine vibe…",
    "searchAccessibility": "Rechercher des événements, clubs ou tags",
    "searchResults": "Résultats de recherche",
    "searchEmpty": "Aucun événement ne correspond à « {query} »",
    "searchEmptySub": "Essaie un autre nom, club ou tag.",
    "loadingEvents": "Chargement des événements...",
    "noEventsFound": "Aucun événement trouvé",
    "noEventsSub": "Revenez bientôt ou essayez un autre filtre."
  },
  "featuredAdmin": {
    "title": "Mettre cet événement à la une",
    "thisWeek": "Cette semaine",
    "nextWeek": "Semaine prochaine",
    "custom": "Personnalisé",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "priority": "Priorité d'affichage",
    "priorityHint": "1 s'affiche en premier. Les nombres les plus bas passent avant.",
    "currentlyFeatured": "Cet événement est actuellement à la une cette semaine.",
    "save": "Enregistrer",
    "saveAnyway": "Mettre à la une quand même",
    "remove": "Retirer",
    "checkingPartner": "Vérification du compte partenaire…",
    "verifiedPartner": "Publié par un partenaire Tonyte vérifié.",
    "notPartner": "Cet événement n'a pas été publié par un compte partenaire vérifié. La mise à la une est prévue pour les événements de partenaires.",
    "unknownPartner": "Impossible de vérifier le compte partenaire. La mise à la une est prévue pour les événements de partenaires.",
    "errors": {
      "invalidDate": "Saisissez les dates au format AAAA-MM-JJ.",
      "endBeforeStart": "La date de fin doit être postérieure à la date de début.",
      "alreadyEnded": "Cette période de mise à la une est déjà terminée.",
      "invalidPriority": "La priorité doit être un entier de 1 à 999.",
      "saveFailed": "Enregistrement impossible. Veuillez réessayer."
    }
  },
  "map": {
    "loadingMap": "Chargement de la carte...",
    "showEvents": "Afficher les événements",
    "hide": "Masquer",
    "noMappedEvents": "Aucun événement cartographié à proximité.",
    "noMappedEventsNearby": "Aucun événement cartographié à proximité",
    "selectDate": "Sélectionner la date",
    "selectCity": "Sélectionnez la ville",
    "myLocation": "Ma position",
    "locating": "Localisation…",
    "locationDeniedTitle": "Localisation refusée",
    "locationDeniedMsg": "Activez l'accès à la localisation dans Paramètres pour utiliser cette fonctionnalité.",
    "locationUnavailableTitle": "Emplacement indisponible",
    "locationUnavailableMsg": "Impossible d'obtenir votre position. Veuillez réessayer.",
    "locationUnavailable": "Localisation indisponible",
    "locationPermissionDenied": "Autorisation de localisation refusée",
    "locationUnavailableHint": "Activez les services de localisation et réessayez.",
    "locationPermissionDeniedHint": "Autorisez l'accès à la localisation dans les paramètres pour utiliser votre position.",
    "recenterToMyLocation": "recentrer sur ma position",
    "invalidSharedLocation": "Cette position ne peut pas être affichée pour le moment.",
    "dismissSharedLocation": "Masquer la position partagée"
  },
  "categories": {
    "social": "Social",
    "adventure": "Aventure",
    "culture": "Culture",
    "food": "Nourriture",
    "nightlife": "Vie nocturne"
  },
  "event": {
    "chatNoLongerAvailable": "Le chat n'est plus disponible",
    "chatNoLongerAvailableBody": "Ce chat n'existe plus car l'événement est terminé.",
    "plan": "Régime",
    "communityPlan": "Plan communautaire",
    "officialEvent": "Événement officiel",
    "clubEvent": "Événement de club",
    "jamSession": "Jam-session",
    "tonight": "Ce soir",
    "interested": "personnes intéressées",
    "interestedCount_one": "{count} personne intéressée",
    "interestedCount_few": "{count} personnes intéressées",
    "interestedCount_many": "{count} personnes intéressées",
    "interestedCount_other": "{count} personnes intéressées",
    "interestedBtn": "Intéressé",
    "members": "membres",
    "memberCount_one": "{count} membre",
    "memberCount_few": "{count} membres",
    "memberCount_many": "{count} membres",
    "memberCount_other": "{count} membres",
    "eventChat": "Discussion d'événement",
    "joiningChat": "Rejoindre…",
    "openVenue": "Lieu ouvert",
    "organizer": "Organisateur",
    "leavePlan": "Plan de congé",
    "requestSentShort": "Demande envoyée",
    "openChat": "Ouvrir le chat",
    "planChat": "Planifier une discussion",
    "dateTba": "Date à déterminer",
    "timeTba": "Heure à déterminer",
    "decline": "Refus",
    "accept": "Accepter",
    "tonyteNight": "Une soirée Tonyte qui vaut la peine d'être présente.",
    "lowRisk": "Risque faible",
    "lowRiskSub": "Plan public ou clairement décrit",
    "caution": "Attention",
    "cautionSub": "Attention particulière recommandée",
    "highRisk": "Risque élevé",
    "highRiskSub": "Détails du forfait privé ou sensible",
    "aboutThisPlan": "À propos de ce forfait",
    "aboutThisEvent": "À propos de cet événement",
    "detailsFinalized": "Les détails sont en cours de finalisation.",
    "lineup": "Programmation",
    "genres": "Genres",
    "signInToJoinChats": "Connectez-vous pour rejoindre les discussions d'événements.",
    "signInToMarkInterested": "Connectez-vous pour marquer les événements comme étant intéressants.",
    "signInToJoinPlans": "Connectez-vous pour rejoindre les forfaits.",
    "chatUnavailable": "Chat indisponible",
    "noEventChat": "Cet événement n'inclut pas de discussion d'événement.",
    "couldNotJoinChat": "Impossible de rejoindre le chat",
    "removedFromPlan": "Vous avez été exclu de ce plan.",
    "requestSent": "Demande envoyée !",
    "organizerWillReview": "L'organisateur examinera votre demande.",
    "couldNotSendRequest": "Impossible d'envoyer la demande",
    "leftPlan": "Plan de gauche",
    "couldNotLeavePlan": "Impossible de quitter le plan",
    "planDeleted": "Forfait supprimé",
    "couldNotDeletePlan": "Impossible de supprimer le plan",
    "couldNotDeleteEvent": "Impossible de supprimer l'événement",
    "noDateAvailable": "Aucune date disponible",
    "noScheduledTime": "Cet événement n'a pas encore d'heure planifiée.",
    "openingGoogleCalendar": "Ouverture du calendrier Google...",
    "confirmCalendarSave": "Confirmez là pour sauvegarder l'événement.",
    "deleteEventQuestion": "Supprimer l'événement ?",
    "deleteEventConfirm": "Etes-vous sûr de vouloir supprimer cet événement ? Cette action ne peut pas être annulée.",
    "joinEventChatQuestion": "Rejoindre le chat de l'événement ?",
    "joinEventChatPrompt": "Vous souhaitez marquer votre intérêt et rejoindre le chat de l'événement ?",
    "interestedOnly": "Intéressé uniquement",
    "joinChat": "Rejoindre le chat",
    "shareEvent": "Partager l'événement",
    "shareOutsideTonyte": "Partager en dehors de Tonyte",
    "sendInTonyteChat": "Envoyer dans le chat Tonyte",
    "foundOnTonyte": "Trouvé ceci sur Tonyte.",
    "openGoogleMaps": "Ouvrir dans les cartes Google",
    "openMaps": "Ouvrir dans Maps",
    "couldNotOpenMaps": "Impossible d'ouvrir les cartes",
    "couldNotOpenEventLink": "Impossible d'ouvrir le lien de l'événement",
    "viewOfficialEvent": "Voir l'événement officiel",
    "capacity": "Capacité",
    "dateTime": "Date et heure",
    "calendar": "Calendrier",
    "addToCalendar": "Ajouter au calendrier",
    "publishedBy": "Publié par",
    "openGoogleCalendar": "Ouvrir le calendrier Google",
    "couldNotOpenCalendar": "Impossible d'ouvrir le calendrier",
    "location": "Localisation",
    "exactLocationAfterApproval": "Emplacement exact partagé dans le chat du plan après approbation.",
    "joinRequests": "Demandes de jointure",
    "couldNotAccept": "Impossible d'accepter",
    "couldNotDecline": "Impossible de refuser",
    "requestToJoin": "Demande d'adhésion ?",
    "highRiskWarning": "Ce plan peut être dans un cadre privé ou sensible. Veuillez redoubler de prudence.",
    "mediumRiskWarning": "Ce plan peut impliquer l'alcool ou la vie nocturne. Soyez attentif à votre environnement.",
    "ackRisks": "Je comprends les risques et je souhaite continuer",
    "messageOrganizerOptional": "Ajouter un message à l'organisateur (facultatif)",
    "sendRequest": "Envoyer la demande",
    "deleteEventConfirmShort": "Êtes-vous sûr ? Cette action ne peut pas être annulée.",
    "requestToJoinFirst": "Demande d'adhésion en premier",
    "requestToJoinFirstMsg": "Envoyez une demande d'adhésion pour accéder au chat du plan une fois acceptée.",
    "cancelRequestQuestion": "Annuler la demande ?",
    "cancelRequestMsg": "Retirer votre demande d'adhésion à ce plan ?",
    "keepRequest": "Conserver la demande",
    "cancelRequest": "Annuler la demande",
    "couldNotCancel": "Impossible d'annuler",
    "adminCannotLeave": "Les administrateurs de plan ne peuvent pas quitter les plans.",
    "deletePlanInstead": "Supprimer ce plan à la place ?",
    "deletePlanQuestion": "Supprimer le forfait ?",
    "noStay": "Non, reste",
    "yesDeletePlan": "Oui, supprimer le plan",
    "venuePost": "Message du lieu",
    "hostedBy": "Hébergé par",
    "addComment": "Ajouter un commentaire...",
    "comments": "Commentaires",
    "tonyteUser": "Utilisateur Tonyte",
    "shareIntro": "Rejoignez cet événement sur Tonyte 🎉",
    "couldNotShare": "Impossible de partager",
    "missingShareableId": "Il manque un identifiant partageable à cet événement.",
    "nativeShareUnavailable": "La feuille de partage native n'est pas disponible pour le moment.",
    "missingExternalLink": "Cet événement n'inclut pas encore de lien.",
    "couldNotUpdateInterest": "Impossible de mettre à jour l'intérêt",
    "eventsCount_one": "{count} événement",
    "eventsCount_few": "{count} événements",
    "eventsCount_many": "{count} événements",
    "eventsCount_other": "{count} événements",
    "joinedCount_one": "{count} participant",
    "joinedCount_few": "{count} participants",
    "joinedCount_many": "{count} participants",
    "joinedCount_other": "{count} participants"
  },
  "plans": {
    "myPlans": "Mes projets",
    "communityPlans": "Plans communautaires",
    "communityPlansSubtitle": "Rejoignez des aventures de groupe près de chez vous",
    "communityPlanBadge": "PLAN COMMUNAUTAIRE",
    "freeBadge": "GRATUIT",
    "postedBy": "Publié par",
    "member": "membre",
    "open": "Ouvrir",
    "leave": "Congé",
    "request": "Demande",
    "loading": "Chargement des plans...",
    "noneYet": "Aucun plan communautaire pour l'instant",
    "noneYetSubtitle": "Créez un plan pour rencontrer de nouvelles personnes et explorer ensemble.",
    "createPlan": "Créer un plan",
    "completeProfile": "Complétez votre profil pour voir les forfaits",
    "addRealProfilePicture": "Ajoutez une vraie photo de profil",
    "completeProfileSubtitle": "Une vraie photo de profil est requise avant de pouvoir rejoindre ou créer des plans communautaires.",
    "signInTitle": "Connectez-vous pour voir les forfaits",
    "signInSubtitle": "Créez un compte pour rejoindre et organiser des aventures de groupe.",
    "signInRequiredSubtitle": "Vous devez vous connecter pour rejoindre les forfaits.",
    "leaveFailed": "Échec de la sortie du plan. Veuillez réessayer.",
    "planDeleted": "Forfait supprimé",
    "removed": "a été supprimé.",
    "deleteFailed": "Impossible de supprimer le plan. Veuillez réessayer.",
    "requestSent": "Demande envoyée !",
    "requestSentSubtitle": "L'organisateur du régime examinera votre demande.",
    "requestFailed": "Impossible d'envoyer votre demande. Veuillez réessayer.",
    "deletePlan": "Supprimer le forfait",
    "deletePlanConfirmPrefix": "Supprimer",
    "deletePlanConfirmSuffix": "définitivement ? Cela ne peut pas être annulé.",
    "templatesTitle": "Besoin d'une idée ?",
    "templatesSubtitle": "Choisissez un plan et faites-en le vôtre."
  },
  "share": {
    "sentToChats": "Envoyé à {count} chat",
    "sentToChatsCount_one": "Envoyé à {count} chat",
    "sentToChatsCount_few": "Envoyé à {count} chats",
    "sentToChatsCount_many": "Envoyé à {count} chats",
    "sentToChatsCount_other": "Envoyé à {count} chats",
    "couldNotSend": "Impossible d'envoyer. Veuillez réessayer."
  },
  "forms": {
    "searchAddressOrVenue": "Rechercher une adresse ou un lieu..."
  },
  "completeProfile": {
    "couldNotSave": "Impossible d'enregistrer. Essayer à nouveau.",
    "couldNotUploadCover": "Impossible de télécharger la photo de couverture.",
    "couldNotUploadProfilePhoto": "Impossible de télécharger la photo de profil.",
    "doneTitle": "Profil amélioré !",
    "complete": "Terminé",
    "doneSub": "Votre profil est désormais plus visible. De meilleures recommandations, des correspondances plus intelligentes et des événements plus pertinents à venir.",
    "backToProfile": "Retour au profil",
    "profileBoost": "AMÉLIORATION DE PROFIL",
    "enhanceExperience": "Améliorez votre expérience",
    "addProfilePicture": "Ajouter une photo de profil",
    "addProfilePictureSub": "Une vraie photo aide les gens à vous reconnaître dans vibes, les chats et les plans.",
    "uploadPhoto": "Télécharger une photo",
    "keepCurrent": "Garder à jour",
    "skipStep": "Ignorer cette étape",
    "dobTitle": "Votre date de naissance",
    "dobSub": "Ceci ne peut être défini qu'une seule fois et reste adapté à l'âge de Tonyte.",
    "dobPlaceholder": "Sélectionnez le jour, le mois, l'année",
    "chooseDob": "Choisissez votre date de naissance pour continuer.",
    "underMinAge": "Tonyte est destiné aux voyageurs âgés de 16 ans et plus.",
    "saveContinue": "Enregistrer et continuer",
    "interestsTitle": "Qu'est-ce que tu aimes ?",
    "interestsSub": "Choisissez-en au moins trois pour que Tonyte puisse affiner vos recommandations.",
    "selected": "sélectionné",
    "pickInterests": "Choisissez au moins 3 centres d'intérêt.",
    "locationTitle": "Où êtes-vous basé ?",
    "locationSub": "Votre ville de base aide Tonyte à garder les gens et les plans pertinents.",
    "city": "Ville",
    "country": "Pays",
    "addBaseCity": "Ajoutez votre ville de base pour continuer.",
    "bioTitle": "Racontez votre histoire",
    "bioSub": "Une courte bio aide les autres à savoir qui ils rencontrent.",
    "bioPlaceholder": "Écrivez quelque chose sur vous : ce qui vous passionne, ce que vous aimez, ce qui vous fait sortir...",
    "coverTitle": "Ajouter une photo de couverture",
    "coverSub": "Une superbe couverture permet à votre profil de se démarquer dans Discover.",
    "tapChooseCover": "Appuyez pour choisir la couverture",
    "uploadCover": "Télécharger la couverture",
    "vibeTitle": "Quel est votre vibe ?",
    "vibeSub": "Votre personnalité de voyageur nous aide à vous recommander les bons événements et les bonnes personnes.",
    "musicTitle": "Vos goûts musicaux",
    "musicSub": "Nous trouverons des événements correspondant à la musique que vous aimez. Choisissez-en jusqu'à 5.",
    "languagesTitle": "Langues que vous parlez",
    "languagesSub": "Trouvez des voyageurs avec qui vous pouvez réellement parler. Choisissez tout ce qui s'applique.",
    "goingOutTitle": "Style de sortie",
    "goingOutSub": "Quel genre de nuits aimez-vous ? Choisissez tout ce qui s'applique.",
    "saveFinish": "Enregistrer et terminer",
    "saveExit": "Enregistrer et quitter",
    "socialVibeButterfly": "Papillon social",
    "socialVibeButterflyDesc": "Vous aimez rencontrer de nouvelles personnes.",
    "socialVibeAdventurer": "Aventurier",
    "socialVibeAdventurerDesc": "Vous recherchez des sensations fortes et de nouveaux lieux.",
    "socialVibeFoodie": "Gourmand",
    "socialVibeFoodieDesc": "La nourriture est votre langage d'amour.",
    "socialVibeNightlife": "Amoureux de la vie nocturne",
    "socialVibeNightlifeDesc": "Les meilleures heures sont après minuit.",
    "socialVibeCulture": "Chasseur de culture",
    "socialVibeCultureDesc": "Musées, art, histoire – tout cela.",
    "socialVibeChill": "Chill et détendu",
    "socialVibeChillDesc": "Déplacement lent, bon vibes.",
    "music_techno": "Techno",
    "music_house": "Maison",
    "music_hipHop": "Hip-Hop",
    "music_rAndB": "R&B",
    "music_pop": "Pop",
    "music_rock": "Rocher",
    "music_indie": "Indépendant",
    "music_edm": "GED",
    "music_jazz": "Jazz",
    "music_classical": "Classique",
    "music_reggaeton": "Reggaeton",
    "music_afrobeats": "Afrobeats",
    "music_loFi": "Lo-Fi",
    "music_drumBass": "Batterie et basse",
    "music_ambient": "Ambiante",
    "spoken_english": "Anglais",
    "spoken_german": "Allemand",
    "spoken_french": "Français",
    "spoken_spanish": "Espagnol",
    "spoken_italian": "Italien",
    "spoken_portuguese": "Portugais",
    "spoken_dutch": "Néerlandais",
    "spoken_polish": "Polonais",
    "spoken_czech": "tchèque",
    "spoken_romanian": "Roumain",
    "spoken_greek": "Grec",
    "spoken_hungarian": "Hongrois",
    "spoken_swedish": "suédois",
    "spoken_danish": "Danois",
    "spoken_finnish": "finnois",
    "spoken_hindi": "hindi",
    "spoken_ukrainian": "Ukrainien",
    "spoken_russian": "Russe",
    "spoken_arabic": "Arabe",
    "spoken_chinese": "Chinois",
    "spoken_japanese": "Japonais",
    "goingOutClubs": "Clubs et fêtes",
    "goingOutBars": "Bars et pubs",
    "goingOutRooftops": "Toits & Terrasses",
    "goingOutLiveMusic": "Musique en direct",
    "goingOutChill": "Points de détente",
    "goingOutStreetFood": "Alimentation de rue et marchés"
  },
  "profile": {
    "myVenueProfile": "Mon profil partenaire",
    "myVenueProfileSub": "Voyez votre lieu comme les visiteurs",
    "basedIn": "Basé à",
    "locationNotAdded": "Emplacement non ajouté",
    "addBio": "Ajoutez quelque chose sur vous-même",
    "recently": "Récemment",
    "events": "Événements",
    "plans": "Forfaits",
    "interests": "Intérêts",
    "attended": "Assisté",
    "created": "Créé",
    "saved": "Enregistré",
    "memberSince": "Membre depuis",
    "exploringSince": "Avec Tonyte depuis.",
    "tapToChangeCity": "Modifier le flux et la ville sur la carte",
    "viewAll": "Tout afficher",
    "addInterest": "Ajouter un intérêt",
    "uploadEvent": "Événement de téléchargement",
    "signOut": "Déconnexion",
    "signOutConfirm": "Êtes-vous sûr de vouloir vous déconnecter ?",
    "cancel": "Annuler",
    "createAccountOrSignIn": "Créer un compte ou se connecter",
    "logOut": "Se déconnecter",
    "personality": "Personnalité",
    "editProfile": "Modifier le profil",
    "shareProfile": "Partager le profil",
    "qrCode": "Code QR",
    "verifications": "Vérifications",
    "vibeVerified": "Vibe Vérifié",
    "studentVerified": "Étudiant Vérifié",
    "earlyMember": "Premier membre",
    "topPlanner": "Planificateur supérieur",
    "eventHost": "Hôte de l'événement",
    "aura": "Aura",
    "myPlans": "Mes projets",
    "loadingPlans": "Chargement des plans...",
    "upcomingPlansEmpty": "Vos projets à venir apparaîtront ici.",
    "createPlan": "Créer un plan",
    "upcomingEvents": "Événements à venir",
    "loadingEvents": "Chargement des événements...",
    "upcomingEventsEmpty": "Aucun événement à venir pour l'instant.",
    "interestedEvents": "Événements intéressés",
    "loadingInterestedEvents": "Chargement des événements intéressés...",
    "interestedEventsEmpty": "Les événements qui vous intéressent apparaîtront ici.",
    "browseEvents": "Parcourir les événements",
    "badgesAchievements": "Insignes et réalisations",
    "savedTemplates": "Modèles enregistrés",
    "reusableEventDrafts": "Brouillons d'événements réutilisables",
    "uploadedPlans": "Plans téléchargés",
    "yourCreatedPlans": "Vos plans créés",
    "planRequests": "Demandes de forfaits",
    "pendingPlanRequests": "Demandes d'adhésion en attente pour vos forfaits",
    "todaysVibe": "Vibe d'aujourd'hui",
    "todaysVibePrompt": "Découvrez votre vibe",
    "todaysVibePromptSub": "Répondez à quelques questions rapides",
    "loadingVibeMatches": "Chargement des correspondances vibe...",
    "vibeMatchWaiting": "Match vibe en attente",
    "vibeMatchesWaiting": "matchs vibe en attente",
    "vibeMatchWaitingCount_one": "{count} match vibe en attente",
    "vibeMatchWaitingCount_few": "{count} matchs vibe en attente",
    "vibeMatchWaitingCount_many": "{count} matchs vibe en attente",
    "vibeMatchWaitingCount_other": "{count} matchs vibe en attente",
    "following": "Abonnements",
    "followingSearch": "Rechercher les partenaires suivis",
    "followingEmpty": "Vous ne suivez encore aucun partenaire. Découvrez-les dans Vibe at Venues.",
    "followingNoMatch": "Aucun partenaire ne correspond à votre recherche.",
    "followingCount_one": "{count} partenaire",
    "followingCount_few": "{count} partenaires",
    "followingCount_many": "{count} partenaires",
    "followingCount_other": "{count} partenaires",
    "studiZoneOpen": "Ouvrir",
    "studiZonePending": "En attente",
    "studiZoneVerify": "À vérifier",
    "updateRole": "Mettre à jour le rôle utilisateur ?",
    "changeRole": "Changer le rôle de {name} de {from} à {to} ?",
    "updateRoleAction": "Mettre à jour le rôle",
    "noRolePermission": "Vous n'êtes pas autorisé à mettre à jour ce rôle.",
    "coAdminRoleRestriction": "Les co-administrateurs ne peuvent pas attribuer ou modifier les comptes administrateur/co-administrateur.",
    "adminSignInRequired": "Vous devez être connecté en tant qu'administrateur pour mettre à jour les rôles.",
    "roleUpdateFailed": "Impossible de mettre à jour le rôle pour le moment.",
    "roleUpdated": "Rôle utilisateur mis à jour.",
    "uploadingProfile": "Téléchargement de la photo de profil…",
    "uploadingCover": "Téléchargement de la photo de couverture…",
    "profileSaved": "Photo de profil enregistrée.",
    "coverSaved": "Photo de couverture enregistrée.",
    "imageUpdateFailed": "Impossible de mettre à jour l'image",
    "removeProfilePhoto": "Supprimer la photo de profil ?",
    "removeCoverPhoto": "Supprimer la photo de couverture ?",
    "restoreDefault": "Cela restaurera l'image par défaut.",
    "remove": "Supprimer",
    "imageRemoveFailed": "Impossible de supprimer l'image",
    "interestsSaveFailed": "Impossible d'enregistrer les intérêts",
    "notificationsSaveFailed": "Impossible d'enregistrer les notifications",
    "reviewFailed": "Impossible d'examiner la demande",
    "unchanged": "Veuillez réessayer : rien n'a été modifié.",
    "revokeFailed": "Impossible de révoquer le badge", "revokeSuccessTitle": "Vibe Verified révoqué", "revokeSuccessBody": "Le badge Vibe Verified de cet utilisateur a été supprimé.",
    "shareFailed": "Impossible de partager",
    "missingShareId": "Il manque un identifiant partageable à ce profil.",
    "shareUnavailable": "La feuille de partage native n'est pas disponible pour le moment.",
    "qrUnavailable": "QR indisponible",
    "vibesHub": "Vibes",
    "vibesHubSub": "Votre chat personnel et vos connexions vibe",
    "admin": "Administrateur",
    "userManagement": "Gestion des utilisateurs",
    "usersCount": "Utilisateurs {count}",
    "adminHelp": "Gérez les rôles Tonyte pour les utilisateurs, les testeurs, les organisateurs, les sites, les co-administrateurs et les administrateurs.",
    "userManagementSub": "Rechercher des utilisateurs et attribuer des rôles.",
    "studentVerifications": "Vérifications des étudiants",
    "faceVerificationRequests": "Demandes de vérification faciale",
    "pendingReviewCount": "{count} en attente de révision",
    "loading": "Chargement…",
    "change": "Modifier",
    "close": "Fermer",
    "myQrCode": "Mon code QR",
    "share": "Partager",
    "coverPhoto": "Photo de couverture",
    "viewCover": "Voir la couverture",
    "changeCover": "Changer la couverture",
    "removeCover": "Retirer le couvercle",
    "pendingReviewCount_one": "{count} en attente de révision",
    "pendingReviewCount_few": "{count} avis en attente",
    "pendingReviewCount_many": "{count} avis en attente",
    "pendingReviewCount_other": "{count} avis en attente",
    "tonyteTraveler": "Voyageur Tonyte",
    "blockedAccountsLoadFailed": "Impossible de charger les comptes bloqués pour le moment.",
    "unblockFailed": "Impossible de débloquer ce compte pour le moment.",
    "noConnectedEmail": "Aucun email n'est connecté à ce compte.",
    "passwordResetSent": "Lien de réinitialisation du mot de passe envoyé à {email}.",
    "passwordResetFailed": "Impossible d'envoyer l'e-mail de réinitialisation pour le moment.",
    "enterValidStudentEmail": "Saisissez une adresse e-mail d'étudiant valide.",
    "studentVerificationEmailSent": "E-mail de vérification envoyé ! Vérifiez la boîte de réception de votre université et cliquez sur le lien pour confirmer.",
    "studentVerificationEmailFailed": "Impossible d'envoyer l'e-mail de vérification. Veuillez réessayer.",
    "feedbackMessageRequired": "Veuillez saisir un message de commentaires.",
    "feedbackTypeRequired": "Veuillez choisir un type de commentaire.",
    "feedbackThanks": "Merci, commentaires envoyés.",
    "feedbackSaveFailed": "Impossible d'enregistrer les commentaires. Veuillez réessayer.",
    "feedbackType_general": "Général",
    "feedbackType_bug": "Bogue",
    "feedbackType_feature": "Demande de fonctionnalité",
    "feedbackType_event_issue": "Problème d'événement",
    "noSignedInUser": "Aucun utilisateur connecté trouvé.",
    "missingEmailForConfirmation": "Il manque à votre compte une adresse e-mail pour la confirmation du mot de passe.",
    "enterPasswordToContinue": "Veuillez saisir votre mot de passe pour continuer.",
    "googleReauthUnavailable": "La réauthentification Google n'est pas disponible dans cette version.",
    "googleMissingIdToken": "La réauthentification de Google n'a pas renvoyé de jeton d'identification.",
    "appleReauthUnavailable": "La réauthentification Apple n'est pas disponible sur cet appareil.",
    "appleMissingIdentityToken": "La réauthentification Apple n'a pas renvoyé de jeton d'identité.",
    "deleteRequiresRecentLogin": "Veuillez vous reconnecter pour confirmer la suppression du compte.",
    "deleteInvalidCredential": "Ce mot de passe ou ces informations de connexion n'ont pas été acceptés. Veuillez réessayer.",
    "deleteUserMismatch": "Veuillez vous authentifier à nouveau avec le même compte actuellement connecté à Tonyte.",
    "deleteReauthInterrupted": "La réauthentification a été interrompue. Veuillez réessayer.",
    "deleteNetworkError": "Erreur réseau. Vérifiez votre connexion et réessayez.",
    "deletePermissionDenied": "Autorisation refusée. Veuillez vous reconnecter et réessayer.",
    "deleteFailedAtStage": "Échec de la suppression du compte à {stage} : {error}",
    "deleteUnavailable": "Impossible de supprimer votre compte pour le moment.",
    "signInAgainBeforeDelete": "Veuillez vous reconnecter avant de supprimer votre compte.",
    "mustSignInToDelete": "Vous devez être connecté pour supprimer votre compte.",
    "accountCleanupFailed": "La requête HTTP de nettoyage du compte a échoué.",
    "selfieUnclear": "Le selfie est trop petit ou peu clair. Veuillez le reprendre sous un bon éclairage avec votre visage et vos gestes visibles.",
    "selfieRequired": "Prenez votre selfie de vérification avant de soumettre.",
    "verificationSyncPending": "Vérification soumise. Synchronisation du statut en attente.",
    "verificationReviewFailed": "L'examen de vérification a échoué.",
    "vibeVerifiedApproved": "Approuvé Vibe Vérifié pour {user}.",
    "verificationClearSelfieFailed": "La vérification a échoué. Veuillez réessayer avec un selfie clair.",
    "revokeNotConfirmed": "La révocation n'a pas confirmé le succès.",
    "shareTitle": "Profil Tonyte",
    "shareMessage": "Découvrez mon profil Tonyte :\n{url}",
    "acceptSaveDomain": "Accepter + Enregistrer le domaine",
    "tonyteUser": "Utilisateur Tonyte",
    "verificationEmailSentTitle": "E-mail de vérification envoyé",
    "verificationPendingTitle": "Vérification en attente",
    "verificationFailedTitle": "Échec de la vérification",
    "studentVerificationTitle": "Vérification de l'étudiant",
    "verificationCheckInboxBody": "Veuillez vérifier votre boîte de réception et confirmer que cet email vous appartient.",
    "verificationReviewingBody": "Nous examinons votre statut d'étudiant.",
    "verificationFailedBody": "Nous n'avons pas pu vérifier votre statut d'étudiant. Veuillez vérifier votre courrier électronique d'étudiant ou réessayer.",
    "verificationUnlockBody": "Débloquez des événements étudiants, des rencontres Erasmus, la vie nocturne du campus, des événements, des plans et des discussions réservés aux étudiants.",
    "studiZoneUnderConstruction": "StudiZone en construction",
    "enterStudiZone": "Entrez StudiZone",
    "verifyStudentStatus": "Vérifier le statut d'étudiant",
    "faq1Question": "Qu'est-ce que Tonyte ?",
    "faq1Answer": "Tonyte vous aide à participer à des événements discover, à rejoindre des projets et à rencontrer des personnes à proximité lorsque vous voyagez ou vivez dans une ville.",
    "faq2Question": "Tonyte est-il gratuit ?",
    "faq2Answer": "Oui, les fonctionnalités de base telles que la découverte d'événements, l'adhésion à des forfaits et le chat sont gratuites.",
    "faq3Question": "Qui peut voir mon profil ?",
    "faq3Answer": "Les utilisateurs peuvent voir votre profil lorsque vous interagissez avec eux via des discussions, des plans, des événements ou des liens de profil partagés.",
    "faq4Question": "Qu'est-ce qu'un plan ?",
    "faq4Answer": "Un plan est une rencontre informelle créée par un utilisateur, comme un café, un barbecue, une visite touristique, des jeux ou une sortie.",
    "faq5Question": "Qui peut créer des plans ?",
    "faq5Answer": "Tout utilisateur connecté peut créer un plan communautaire.",
    "faq6Question": "Que se passe-t-il lorsque j'adhère à un plan ?",
    "faq6Answer": "Vous pouvez être ajouté à la liste des participants du plan et accéder au chat du plan.",
    "faq7Question": "Puis-je quitter un plan ?",
    "faq7Answer": "Oui, les participants normaux peuvent quitter un plan. Les organisateurs ne peuvent pas quitter leur propre plan à moins de le supprimer.",
    "faq8Question": "Un organisateur peut-il me retirer d'un forfait ?",
    "faq8Answer": "Oui. Les organisateurs peuvent retirer des personnes de leurs propres projets pour gérer la sécurité et le confort.",
    "faq9Question": "Que se passe-t-il si je suis retiré d'un plan ?",
    "faq9Answer": "Vous ne pouvez pas rejoindre ce plan, mais vous pouvez toujours consulter le chat et signaler le plan ou des utilisateurs spécifiques si nécessaire.",
    "faq10Question": "Qui peut m'envoyer un message ?",
    "faq10Answer": "Les gens peuvent vous envoyer des messages via des matchs, des discussions d'événements ou des discussions de planification.",
    "faq11Question": "Pourquoi ne puis-je pas envoyer de messages dans un chat ?",
    "faq11Answer": "Vous n'êtes peut-être plus un participant actif ou vous avez peut-être été supprimé de ce plan/de cette discussion.",
    "faq12Question": "Puis-je signaler quelqu'un ?",
    "faq12Answer": "Oui. Vous pouvez signaler des utilisateurs, des projets, des événements ou un comportement de chat si quelque chose vous semble dangereux, abusif, discriminatoire ou inapproprié.",
    "faq13Question": "Ma position exacte est-elle visible ?",
    "faq13Answer": "Non. La localisation est utilisée pour afficher les événements et les plans à proximité. Votre position exacte en direct n'est pas affichée aux autres utilisateurs.",
    "faq14Question": "Puis-je modifier mon profil ?",
    "faq14Answer": "Oui. Vous pouvez mettre à jour votre nom, votre ville, votre biographie, vos photos et vos centres d'intérêt à tout moment.",
    "faq15Question": "Comment supprimer mon compte ?",
    "faq15Answer": "Accédez à Paramètres du profil → Supprimer le compte.",
    "faq16Question": "L'application ne fonctionne pas correctement. Que dois-je faire?",
    "faq16Answer": "Utilisez l'aide et les commentaires dans les paramètres et décrivez le problème."
  },
  "vibes": {
    "synchronize": "Synchroniser",
    "lockInToday": "Verrouillez le vibe d'aujourd'hui",
    "getYourVibesSynchronized": "Synchronisez votre Vibes",
    "getYourVibesSynchronizedFlat": "Synchronisez votre vibes",
    "vibeCircle": "Cercle Vibe",
    "vibeAlignment": "Alignement Vibe",
    "sharedFrequency": "Fréquence partagée",
    "instantSync": "Synchronisation instantanée",
    "strongSync": "Synchronisation forte",
    "recommendedVibe": "Recommandé Vibe",
    "openChat": "Ouvrir le chat",
    "continueChat": "Continuer la discussion",
    "sendVibe": "Envoyer vibe",
    "startSync": "Démarrer la synchronisation",
    "pickAllHint": "Choisissez dès maintenant tout ce qui convient à votre vibe.",
    "dontOverthink": "N'y réfléchissez pas trop.",
    "pickUpTo": "Ramasser à",
    "couldNotSaveVibe": "Impossible d'enregistrer",
    "couldNotSaveVibeSub": "Impossible d'enregistrer votre vibe pour l'instant. Veuillez réessayer.",
    "icebreakersReady": "Deux questions brise-glace sont prêtes dans votre chat.",
    "suggestedIcebreaker": "Brise-glace suggéré",
    "signalLocked": "signal verrouillé",
    "signalsLocked": "signaux validés",
    "signalLockedCount_one": "{count} signal validé",
    "signalLockedCount_few": "{count} signaux validés",
    "signalLockedCount_many": "{count} signaux validés",
    "signalLockedCount_other": "{count} signaux validés",
    "chooseOneSignal": "Choisissez un signal",
    "chooseUpTo": "Choisissez jusqu'à",
    "next": "Suivant",
    "microcopy0": "N'y réfléchissez pas trop.",
    "microcopy1": "Allez avec l'énergie d'aujourd'hui.",
    "microcopy2": "Cela peut changer demain.",
    "microcopy3": "vibe actuel uniquement.",
    "microcopy4": "Soyez honnête.",
    "microcopy5": "Le premier instinct est généralement le bon.",
    "dayVibesBadge": "JOUR VIBES",
    "questionOf": "Question",
    "resultsUnlock1pm": "Résultats débloqués à 13h00 PM",
    "lastOne": "Le dernier !",
    "questionsLeft": "questions restantes",
    "questionLeft": "question restante",
    "questionLeftCount_one": "Il reste {count} question",
    "questionLeftCount_few": "Il reste {count} questions",
    "questionLeftCount_many": "Il reste {count} questions",
    "questionLeftCount_other": "Il reste {count} questions",
    "openAt6am": "L'analyse aura d'aujourd'hui s'ouvre à 6h00 AM.",
    "resetDaily": "Nouvelles questions et résultats du cercle Vibe réinitialisés avec le nouveau jour.",
    "loadingAura": "Chargement du aura d'aujourd'hui...",
    "noAuraToday": "Aucun aura trouvé pour aujourd'hui.",
    "goBack": "Retour",
    "todaysAura": "Aura d'aujourd'hui",
    "todayYouAre": "AUJOURD'HUI VOUS ÊTES",
    "resultsIn": "Résultats dans",
    "basedOnToday": "Basé sur le jour d'aujourd'hui Vibes",
    "findingWavelength": "Trouver des personnes sur votre longueur d'onde...",
    "noAlignmentYet": "Pas encore d'alignement Vibe",
    "noAlignmentSubtitle": "Personne sur ta longueur d'onde n'a encore terminé le jeu du jour. De nouveaux matchs peuvent arriver quand d'autres jouent — ils s'afficheront ici automatiquement.",
    "firstVibesUnlock": "C'est bon ! Tes premières vibes se débloquent à 13h00.",
    "moreMatchesLater": "D'autres matchs peuvent arriver quand d'autres personnes jouent ensuite — ton Cercle Vibe se met à jour toute la journée.",
    "matchingInProgress": "Recherche de tes vibes…",
    "matchingInProgressBody": "Nous te comparons à toutes les personnes qui ont joué aujourd'hui. Cela se met à jour tout seul.",
    "matchingRetryingBody": "Cela prend un peu plus de temps que d'habitude — on s'en occupe. Tes vibes apparaîtront ici automatiquement.",
    "moreCanArrive": "D'autres vibes peuvent arriver quand d'autres terminent le jeu du jour.",
    "resultsRightAway": "Résultats dès la fin du jeu",
    "refresh": "Actualiser",
    "sync": "synchronisation",
    "sharedFrequencyToday": "fréquence partagée aujourd'hui",
    "sharedFrequenciesToday": "fréquences partagées aujourd'hui",
    "alignmentPercentPrefix": "Votre alignement vibe est",
    "icebreakerPrompt1": "À quoi diriez-vous vraiment tous les deux oui aujourd'hui ?",
    "icebreakerPrompt2": "Quel paramètre permettrait à votre vibe partagé de se sentir sans effort ?",
    "auraCitySoulName": "Âme de la ville",
    "auraCitySoulDescription": "Vous donnez aujourd'hui une énergie curieuse, cinématographique et tranquillement aventureuse.",
    "auraCitySoulTrait1": "Explorateur de la ville",
    "auraCitySoulTrait2": "Réseaux sociaux doux",
    "auraCitySoulTrait3": "Ambiance esthétique",
    "auraSoftChaosName": "Chaos doux",
    "auraSoftChaosDescription": "Des projets spontanés, des étincelles sociales et une énergie magnifiquement déstructurée.",
    "auraSoftChaosTrait1": "Spontané",
    "auraSoftChaosTrait2": "Trémie de café",
    "auraSoftChaosTrait3": "Social aujourd'hui",
    "auraGoldenHourName": "Heure d'or",
    "auraGoldenHourDescription": "Chaleureux, sans hâte et rayonnant d'une présence intentionnelle aujourd'hui.",
    "auraGoldenHourTrait1": "Intentionnel",
    "auraGoldenHourTrait2": "Chercheur de chaleur",
    "auraGoldenHourTrait3": "L'instant présent",
    "auraNeonWolfName": "Loup Néon",
    "auraNeonWolfDescription": "Audacieux, chargé et fonctionnant aujourd'hui à l'énergie électrique indépendante.",
    "auraNeonWolfTrait1": "Indépendant",
    "auraNeonWolfTrait2": "Électriquement gras",
    "auraNeonWolfTrait3": "Prêt pour la nuit",
    "auraQuietStormName": "Tempête tranquille",
    "auraQuietStormDescription": "Profondément présent, créatif et puissant aujourd'hui.",
    "auraQuietStormTrait1": "Introspective",
    "auraQuietStormTrait2": "Orienté vers la créativité",
    "auraQuietStormTrait3": "Profondément conscient",
    "auraSolarBurstName": "Explosion solaire",
    "auraSolarBurstDescription": "Radiant, magnétique et débordant d'énergie extérieure aujourd'hui.",
    "auraSolarBurstTrait1": "Haute énergie",
    "auraSolarBurstTrait2": "Rayonnant Ouvert",
    "auraSolarBurstTrait3": "Magnétiquement Social",
    "reset": "Réinitialiser",
    "scan": "Numérisation",
    "auraBadgeAccessibility": "Insigne {name} aura",
    "auraBadgeHint": "Élargit la description actuelle du aura"
  },
  "venues": {
    "vibeAtVenues": "Vibe sur les sites"
  },
  "imageCrop": {
    "profilePhoto": "Photo de profil",
    "eventPhoto": "Photo de l’événement",
    "coverPhoto": "Photo de couverture",
    "frameProfile": "Cadre ta photo de profil",
    "frameEvent": "Cadre la photo de l’événement",
    "frameCover": "Cadre ta photo de couverture",
    "previewBeforeSaving": "Vérifie l’image avant de l’enregistrer.",
    "dragToReposition": "Fais glisser la photo pour la repositionner",
    "fitEntireImage": "Afficher l’image entière",
    "cropToFill": "Recadrer pour remplir",
    "completeImageHint": "L’image complète sera enregistrée",
    "viewFullImage": "Afficher l’image complète de l’événement",
    "zoom": "Zoom",
    "cropping": "Recadrage...",
    "useImage": "Utiliser l’image"
  },
  "appUpdate": {
    "defaultTitle": "Tonyte vient de s’améliorer",
    "defaultMessage": "Nous avons amélioré les cartes, les plans, les profils et l’expérience globale de l’app.",
    "newVersion": "Nouvelle version disponible",
    "newVersionNamed": "Nouvelle version {version} disponible",
    "opening": "Ouverture...",
    "updateNow": "Mettre à jour",
    "optionalTitle": "Mettez à jour Tonyte 🧡",
    "optionalMessage": "Une version plus récente est disponible avec les dernières fonctionnalités, corrections et améliorations.",
    "requiredTitle": "Tonyte doit être mis à jour",
    "requiredMessage": "Veuillez mettre à jour Tonyte pour continuer à utiliser l'app.",
    "updateTonyte": "Mettre à jour Tonyte",
    "notNow": "Pas maintenant"
  },
  "languages": {
    "en": "Anglais",
    "de": "Allemand",
    "es": "Espagnol",
    "fr": "Français",
    "ru": "Russe"
  },
  "onboarding": {
    "languageTitle": "Choisissez votre langue",
    "languageSub": "Tonyte s'exprimera désormais dans votre langue. Vous pouvez la modifier à tout moment dans les Paramètres.",
    "travelerProfile": "Votre profil voyageur",
    "displayNameTitle": "Comment les voyageurs devraient-ils vous appeler ?",
    "displayNameSub": "Choisissez un nom qui vous ressemble.",
    "displayNameLabel": "NOM D'AFFICHAGE",
    "displayNamePlaceholder": "Votre nom d'affichage",
    "changeLater": "Vous pourrez modifier cela ultérieurement.",
    "continue": "Continuer",
    "photoTitle": "Ajoutez un visage à votre profil",
    "photoSub": "Une photo de profil aide les autres à reconnaître qui ils rencontrent.",
    "tapUpload": "Appuyez pour télécharger",
    "addPhoto": "Ajouter une photo de profil",
    "skipNow": "Passer pour l'instant",
    "dobTitle": "Quelle est votre date de naissance ?",
    "dobSub": "Cela aide Tonyte à maintenir ses plans et ses découvertes en fonction de son âge.",
    "dobLabel": "DATE DE NAISSANCE",
    "invalidDob": "Veuillez choisir une date de naissance valide.",
    "dobReady": "Date de naissance ajoutée — vous pouvez continuer.",
    "continueLocked": "Continuer · date requise",
    "interests": "Intérêts",
    "selected20": "{count}/20 sélectionné",
    "unlockStudiZone": "Déverrouiller StudiZone",
    "unlockStudiZoneSub": "Vérifiez votre statut d'étudiant pour accéder aux événements réservés aux étudiants, aux plans Erasmus, aux communautés de campus et aux discussions privées entre étudiants.",
    "campusEvents": "Événements sur le campus",
    "erasmusPlans": "Plans Erasmus",
    "studentChats": "Discussions avec les étudiants",
    "verifiedGuestlist": "Liste d'invités vérifiée",
    "universityEmail": "COURRIEL UNIVERSITAIRE",
    "universityEmailPlaceholder": "your@university.edu",
    "universityEmailHelp": "Saisissez l'adresse e-mail de votre université pour examen par l'administrateur. Pas de spam, jamais.",
    "submitVerification": "Soumettre pour vérification",
    "skipVerification": "Ignorer pour l'instant – vérifier plus tard à partir du profil",
    "guidelinesTitle": "Règlement de la communauté",
    "guidelinesSub": "Tonyte repose sur la confiance et le respect. Lisez et acceptez avant de rejoindre.",
    "guidelineRespect": "Traitez chaque voyageur avec respect, en ligne et en personne.",
    "guidelineHarassment": "Tolérance zéro pour le harcèlement, les discours de haine ou les abus.",
    "guidelineRealEvents": "Publiez uniquement des événements et des plans réels et précis.",
    "guidelineSafety": "Donnez la priorité à la sécurité dans toutes les dispositions relatives aux rencontres.",
    "guidelineData": "Vos données sont protégées. Nous ne vendons pas vos informations.",
    "guidelineReport": "Signalez le contenu nuisible à l'aide du bouton d'indicateur intégré à l'application.",
    "viewTerms": "Afficher les conditions d'utilisation",
    "viewPrivacy": "Afficher la politique de confidentialité",
    "agreeTerms": "J'accepte les conditions d'utilisation et le règlement de la communauté.",
    "enterTonyte": "Entrez Tonyte →",
    "skipPhotoTitle": "Ignorer la photo de profil ?",
    "skipPhotoBody": "Sans photo de profil, vous ne pourrez peut-être pas accéder à toutes les fonctionnalités telles que Discover, rejoindre des forfaits ou créer des forfaits.",
    "uploadPicture": "Télécharger une photo",
    "skipAnyway": "Sauter quand même",
    "displayNameMin": "Le nom d'affichage doit comporter au moins 2 caractères.",
    "displayNameSaveFailed": "Impossible d'enregistrer le nom d'affichage.",
    "choosePhoto": "Choisissez une photo de profil ou ignorez-la pour l'instant.",
    "photoSaveFailed": "Impossible d'enregistrer la photo de profil.",
    "photoSkipFailed": "Impossible d'ignorer la photo de profil.",
    "dobRequired": "Entrez votre date de naissance pour continuer.",
    "ageRequirement": "Tonyte est destiné aux voyageurs âgés de {age} et plus. Veuillez vérifier votre date de naissance.",
    "profileSaveFailed": "Impossible d'enregistrer le profil.",
    "verificationSendFailed": "Impossible d'envoyer l'e-mail de vérification. Vérifiez l'adresse et réessayez.",
    "skipFailed": "Impossible de sauter.",
    "acceptTerms": "Veuillez accepter les conditions et le règlement de la communauté pour continuer.",
    "setupFailed": "Impossible de terminer la configuration.",
    "themeKicker": "FAITES DE TONYTE LE VÔTRE",
    "themeTitle": "Choisissez votre style",
    "themeSubtitle": "Choisissez le visage de Tonyte qui vous ressemble.",
    "themeDaylight": "LUMIÈRE DU JOUR",
    "themeDaylightDescriptor": "Clair · Chaleureux · Social",
    "themeMidnight": "MINUIT",
    "themeMidnightDescriptor": "Sombre · Audacieux · Électrique",
    "themeSwitchAnytime": "Vous pouvez changer à tout moment depuis votre Profil.",
    "themeNotPermanent": "Ce n’est pas permanent — changez à tout moment depuis votre Profil.",
    "themeEnter": "Entrer dans Tonyte",
    "selectThemeRequired": "Choisissez Lumière du jour ou Minuit pour entrer dans Tonyte."
  },
  "library": {
    "myPosts": "Mes messages",
    "profileEyebrow": "PROFIL",
    "events": "événements",
    "plans": "plans",
    "search": "Recherche par titre, lieu, ville, tags…",
    "loadingPosts": "Chargement des messages…",
    "edit": "Modifier",
    "repost": "Republier",
    "planEditing": "Edition du plan",
    "planEditingUnavailable": "L'édition du plan n'est pas encore disponible.",
    "permissionRequired": "Autorisation requise",
    "deletePermission": "Seuls l'organisateur de l'événement ou les administrateurs peuvent supprimer cette publication.",
    "deletePost": "Supprimer le message",
    "deletePostFailed": "Impossible de supprimer le message. Essayer à nouveau.",
    "organizerLibrary": "BIBLIOTHÈQUE ORGANISATEUR",
    "savedTemplates": "Modèles enregistrés",
    "loadingTemplates": "Chargement des modèles…",
    "eventTemplate": "MODÈLE D'ÉVÉNEMENT",
    "useTemplate": "Utiliser le modèle",
    "deleteTemplate": "Supprimer le modèle",
    "deleteTemplateFailed": "Impossible de supprimer le modèle. Essayer à nouveau.",
    "deleteConfirm": "Supprimer « {title} » ? Cela ne peut pas être annulé.",
    "noMatches": "Aucune correspondance",
    "noPosts": "Pas encore de messages",
    "searchAgain": "Essayez un autre terme de recherche.",
    "noPostsSub": "Créez un événement ou un plan communautaire pour commencer.",
    "communityPlan": "PLAN COMMUNAUTAIRE",
    "officialEvent": "ÉVÉNEMENT OFFICIEL",
    "noTemplates": "Aucun modèle enregistré",
    "noTemplatesSub": "Créez un événement et enregistrez-le comme modèle pour une réutilisation rapide.",
    "untitled": "Sans titre",
    "noVenue": "Aucun lieu"
  },
  "planRequests": {
    "empty": "Aucune demande en attente",
    "emptySub": "Les demandes d'adhésion de vos plans communautaires apparaîtront ici.",
    "new": "NOUVEAU",
    "noMessage": "Aucun message",
    "decline": "Refuser",
    "accept": "Accepter",
    "acceptFailed": "Impossible d'accepter la demande. Veuillez réessayer.",
    "declineFailed": "Impossible de refuser la demande. Veuillez réessayer.",
    "studiZoneAdmin": "ADMINISTRATEUR STUDIZONE",
    "planAdmin": "ADMINISTRATEUR DU RÉGIME",
    "studiZoneRequests": "Requêtes StudiZone",
    "joinRequests": "Demandes de jointure",
    "traveler": "Voyageur",
    "communityPlan": "Plan communautaire",
    "viewProfile": "Voir le profil",
    "profileUnavailable": "Profil indisponible",
    "profileUnavailableBody": "Le profil de cette personne est introuvable."
  },
  "publicProfile": {
    "reportFailed": "Impossible de soumettre le rapport",
    "blockTitle": "Bloquer l'utilisateur ?",
    "blockFailed": "Impossible de bloquer l'utilisateur",
    "profileUnavailableTitle": "Profil indisponible",
    "profileUnavailableBody": "Ce profil n'existe plus ou n'est pas disponible pour le moment.",
    "vibeScore": "SCORE VIBE",
    "match": "% de correspondance",
    "unvibe": "Annuler l'ambiance",
    "report": "Rapport",
    "about": "À propos",
    "publicPlans": "Régimes publics",
    "publicEvents": "Événements publics",
    "safetyHint": "Les actions de signalement et de blocage sont disponibles à partir de votre menu de discussion directe.",
    "safety": "SÉCURITÉ",
    "optionalDetails": "Détails facultatifs...",
    "unvibeWith": "Unvibe avec {name} ?",
    "unvibeBody": "Cela supprime votre connexion et votre chat direct.",
    "keepVibe": "Conserver Vibe",
    "community": "Communauté Tonyte",
    "reportSubmitted": "Rapport soumis",
    "blockMessage": "Vous ne verrez plus les messages de {name}. Le blocage est à sens unique et ne les avertira pas.",
    "userBlocked": "Utilisateur bloqué",
    "vibeSent": "Vibe envoyé à {name}",
    "vibeSendFailed": "Impossible d'envoyer vibe",
    "noLongerVibing": "Vous et {name} ne vibrez plus",
    "unvibeFailed": "Impossible d'annuler l'ambiance pour le moment",
    "message": "Message",
    "vibeSentStatus": "Vibe Envoyé",
    "sendVibe": "Envoyer Vibe",
    "blocking": "Blocage...",
    "block": "Bloquer",
    "reportPerson": "Rapport {name}",
    "sending": "Envoi...",
    "submitReport": "Soumettre le rapport",
    "removing": "Suppression...",
    "reasonSpam": "Pourriel",
    "reasonHarassment": "Harcèlement",
    "reasonFake": "Faux profil",
    "reasonContent": "Contenu inapproprié",
    "reasonScam": "Arnaque ou comportement dangereux",
    "reasonOther": "Autre",
    "eventFallback": "Événement",
    "planFallback": "Régime"
  },
  "promotions": {
    "sectionTitle": "Collections",
    "explore": "Découvrir les événements",
    "eventsCount": "{count} événements",
    "collection": "Collection",
    "runs": "Du {range}",
    "dateRangeNote": "Des événements sur toute cette période, pas seulement le jour choisi dans ton fil.",
    "unavailableTitle": "Cette collection n’est pas disponible",
    "unavailableSub": "Elle est peut-être terminée ou a été retirée. Consulte le fil des événements pour voir ce qui se passe.",
    "backToEvents": "Retour aux événements"
  },
  "studiZone": {
    "locked": "StudiZone verrouillé",
    "lockedSub": "Vérifiez votre statut d'étudiant pour débloquer des événements étudiants, des rencontres Erasmus, des plans de campus et la vie nocturne universitaire.",
    "verifyStatus": "Vérifier le statut d'étudiant",
    "underConstruction": "en construction",
    "constructionSub": "Nous mettons la touche finale à StudiZone. Votre statut vérifié est enregistré : vous aurez un accès complet lors de son lancement.",
    "verifiedLayer": "Couche étudiant vérifiée",
    "exit": "Quitter",
    "loading": "Chargement de StudiZone...",
    "createPlan": "Créer un forfait étudiant",
    "planChat": "Chat du plan StudiZone · Membres {count}",
    "unlockedSub": "Les forfaits réservés aux étudiants, les discussions et la vie nocturne sur le campus sont débloqués pour ce profil.",
    "planRequests": "Demandes de forfaits",
    "soon": "Bientôt",
    "campusMap": "Plan du campus",
    "studentPins": "Épinglettes d'étudiant {count}",
    "openMap": "Ouvrir la carte complète",
    "emptyLane": "Rien pour l'instant dans cette voie",
    "emptyLaneSub": "StudiZone est prêt pour les sorties réservées aux étudiants, les sociétés, les événements sur le campus et les plans Erasmus.",
    "loadingMap": "Chargement de la carte des étudiants...",
    "mapTitle": "Plan du campus",
    "pins": "Broches StudiZone",
    "tonyteStudent": "Étudiant Tonyte",
    "studentDiscounts": "Rabais étudiants",
    "universityCommunities": "Communautés universitaires",
    "societiesClubs": "Sociétés & clubs",
    "campusHeatmaps": "Cartes thermiques du campus",
    "categoryAll": "Tous",
    "categoryCampus": "Campus",
    "categoryParties": "Parties",
    "categoryErasmus": "Erasmus",
    "categoryWorkshops": "Ateliers",
    "categorySports": "Sport",
    "categoryFree": "Gratuit",
    "tabFeed": "Fil",
    "hey": "Salut {name}",
    "upcoming": "À venir",
    "eventsCount": "{count} événements",
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "free": "Gratuit",
    "verified": "Vérifié",
    "timeTba": "Heure à venir",
    "campusMapSub": "Découvre ce qui se passe sur le campus",
    "searchUniversities": "Rechercher une université",
    "dresden": "Dresde",
    "campusEventsCount": "{count} événements sur le campus",
    "noCampusEvents": "Aucun événement sur ce campus pour l’instant",
    "noCampusEventsSub": "Les événements situés dans un bâtiment du campus apparaissent ici.",
    "buildingFilter": "Bâtiment {code}",
    "noUniversityResults": "Aucune université trouvée",
    "yourUniversity": "Ta fac",
    "campusesCount": "{count} campus",
    "allEvents": "Tous les événements StudiZone",
    "tabPlans": "Forfaits",
    "tabChats": "Discussions",
    "tabProfile": "Profil"
  },
  "verification": {
    "signInSub": "Veuillez vous connecter pour lancer la vérification.",
    "title": "Centre de vérification",
    "subtitle": "Gérez les badges de confiance et l'accès StudiZone en option à partir d'un seul endroit.",
    "vibe": "Vérification Vibe",
    "retake": "Reprendre",
    "student": "Vérification de l'étudiant",
    "emailPlaceholder": "name@university.edu",
    "backToTonyte": "Retour à Tonyte",
    "validStudentEmail": "Saisissez une adresse e-mail d'étudiant valide.",
    "emailSent": "E-mail de vérification envoyé. Vérifiez votre boîte de réception universitaire.",
    "emailSendFailed": "Impossible d'envoyer l'e-mail de vérification.",
    "selfieTooSmall": "Le selfie est trop petit ou peu clair. Reprenez-le avec une bonne lumière et votre visage visible.",
    "submitted": "Soumis pour examen.",
    "submitFailed": "Impossible de soumettre la vérification.",
    "verified": "Vérifié",
    "pending": "En attente",
    "failed": "Échec",
    "notVerified": "Non vérifié",
    "vibeDescription": "Un badge de confiance et de sécurité qui montre aux autres personnes que votre profil appartient à une personne réelle. Votre selfie de vérification est examiné manuellement et supprimé une fois la décision de vérification prise.",
    "studentDescription": "Vérification facultative pour les personnes souhaitant accéder à StudiZone. Cela ne change pas l’expérience principale du Tonyte.",
    "pendingReview": "En attente de révision",
    "tryAgain": "Réessayez",
    "start": "Démarrer la vérification",
    "submitting": "Soumission...",
    "submitReview": "Soumettre pour révision",
    "poseGuideTitle": "Obtenez votre Vibe Vérifié",
    "poseGuideBody": "Vérification faciale rapide\n\nNous prendrons trois photos automatiquement :\n• Regard droit devant\n• Regard vers votre gauche\n• Regard vers votre droite\n\nAssurez-vous que votre visage est bien visible et que vous êtes dans un endroit bien éclairé.\n\nVos photos sont soumises en toute sécurité pour vérification et peuvent être examinées par l'équipe Tonyte.",
    "poseGuideOpenCamera": "Continuer",
    "camera": {
      "requestingPermission": "Demande d'accès à la caméra…",
      "permissionDenied": "L'accès à la caméra est nécessaire pour vérifier votre Vibe. Activez-le dans les Réglages et réessayez.",
      "openSettings": "Ouvrir les Réglages",
      "onePersonOnly": "Une seule personne doit être dans le cadre",
      "of": "sur",
      "moveIntoFrame": "Placez votre visage dans le cadre",
      "lookStraight": "Regardez droit vers la caméra",
      "turnLeft": "Montrez votre profil gauche",
      "turnRight": "Montrez maintenant votre profil droit",
      "holdStill": "Ne bougez plus…",
      "faceDetected": "Visage détecté ✓",
      "frontCaptured": "✓ Face capturée",
      "leftCaptured": "✓ Profil gauche capturé",
      "rightCaptured": "✓ Profil droit capturé",
      "verificationComplete": "Vous êtes Vibe Vérifié ✓",
      "uploading": "Envoi de vos photos…",
      "fallbackMessage": "Impossible de vérifier automatiquement. Vous pouvez soumettre vos photos pour une révision manuelle.",
      "fallbackSubmit": "Soumettre pour révision manuelle",
      "tryAgain": "Réessayer",
      "errorGeneric": "Impossible de terminer la vérification. Assurez-vous que votre visage est bien visible et réessayez."
    }
  },
  "uploadPlan": {
    "signInBody": "Connectez-vous avant de créer un plan.",
    "missingDetails": "Détails manquants",
    "missingDetailsBody": "Ajoutez un titre et une description du plan.",
    "missingLocation": "Emplacement manquant",
    "missingLocationBody": "Ajoutez le lieu et la ville de la réunion.",
    "missingDate": "Date manquante",
    "missingDateBody": "Sélectionnez la date et l'heure de début.",
    "participantLimit": "Limite de participants",
    "participantLimitBody": "Le nombre maximum de participants au régime doit être d'au moins 2.",
    "safetySetup": "Configuration de sécurité",
    "safetySetupBody": "Reconnaître la responsabilité en matière de sécurité avant de publier.",
    "invalidDate": "Date invalide",
    "futureDate": "Veuillez sélectionner aujourd'hui ou une date ultérieure.",
    "invalidTime": "Heure invalide",
    "pastTime": "L'heure de début ne peut pas être située dans le passé.",
    "publishFailed": "Impossible de publier le plan",
    "back": "← Retour",
    "communityPlan": "Plan communautaire",
    "createPlan": "Créer un plan",
    "alwaysFree": "Les forfaits sont toujours gratuits",
    "alwaysFreeBody": "Les forfaits communautaires ne peuvent pas permettre de paiements ou de tickets.",
    "title": "Titre du régime",
    "description": "Description du régime",
    "city": "Ville",
    "cityHelp": "Les plans s'affichent uniquement à l'intérieur de la ville sélectionnée.",
    "chooseCity": "Choisissez votre ville",
    "dateRange": "Plage de dates",
    "dateRangeHelp": "Aidez les autres à savoir quand et où se rencontrer.",
    "location": "Localisation",
    "locationPlaceholder": "Où faut-il se retrouver ?",
    "dateFrom": "Date de",
    "timeFrom": "Heure de",
    "safety": "Configuration de sécurité",
    "safetyHelp": "Aidez les autres à comprendre à quel type de plan ils adhèrent.",
    "hostedAt": "Hébergé à",
    "hostedHelp": "Choisissez si ce forfait est hébergé dans un lieu public, un lieu privé ou un type d'emplacement inconnu.",
    "visibility": "Visibilité du plan",
    "visibilityHelp": "Choisissez qui peut discover ce plan.",
    "maxParticipants": "Nombre maximum de participants (facultatif)",
    "unlimited": "Laisser vide pour illimité",
    "responsibility": "Je comprends que je suis responsable de créer un plan sécuritaire et respectueux.",
    "publish": "Publier le plan",
    "publicPlace": "Lieu public",
    "privatePlace": "Lieu privé",
    "unknown": "Inconnu",
    "public": "Publique",
    "friends": "Amis",
    "inviteOnly": "Sur invitation uniquement",
    "startedFromTemplate": "Basé sur un modèle Tonyte",
    "endsAt": "Fin du plan",
    "endsAtHelp": "Le plan disparaît de Tonyte après cette heure, puis il est supprimé automatiquement.",
    "endDate": "Date de fin",
    "endTime": "Heure de fin",
    "missingEnd": "Heure de fin manquante",
    "missingEndBody": "Choisissez quand le plan se termine.",
    "endBeforeStart": "Le plan doit se terminer après son début.",
    "endTooLate": "Un plan peut durer 14 jours maximum."
  },
  "uploadEvent": {
    "signInBody": "Connectez-vous avant de publier un événement.",
    "missingDetails": "Détails manquants",
    "missingDetailsBody": "Ajoutez un titre et une description de l'événement.",
    "missingDate": "Date manquante",
    "missingDateBody": "Sélectionnez la date et l'heure de début.",
    "participantLimit": "Limite de participants",
    "participantLimitBody": "Entrez 0 pour illimité ou une limite de participants supérieure à 0.",
    "invalidDate": "Date invalide",
    "futureDate": "Veuillez sélectionner aujourd'hui ou une date ultérieure.",
    "invalidTime": "Heure invalide",
    "startPast": "L'heure de début ne peut pas être située dans le passé.",
    "endBeforeStart": "La date de fin ne peut pas être antérieure à la date de début.",
    "endTimeBeforeStart": "L'heure de fin doit être postérieure à l'heure de début.",
    "untilBeforeStart": "La date de fin ne peut pas être antérieure à la date de début de l'événement.",
    "tagRequired": "Balise d'événement requise",
    "tagRequiredBody": "Veuillez sélectionner au moins un tag d'événement afin que les gens puissent discover votre événement.",
    "permissionRequired": "Autorisation requise",
    "editPermission": "Seuls les administrateurs, les co-administrateurs et l'organisateur de l'événement peuvent modifier cet événement.",
    "addressWarning": "Nous n'avons pas pu vérifier cette adresse exacte, mais nous l'enregistrerons telle que saisie.",
    "publishFailed": "Impossible de publier l'événement",
    "back": "← Retour",
    "officialEvent": "Événement officiel",
    "editEvent": "Modifier l'événement",
    "repostEvent": "Republier l'événement",
    "fromTemplate": "Nouveau à partir du modèle",
    "createEvent": "Créer un événement",
    "addCover": "Ajouter une photo de couverture",
    "invalidImage": "Image d’événement non valide",
    "imageTooLarge": "Choisissez une image de moins de 15 Mo.",
    "unsupportedImage": "Choisissez une image JPEG, PNG, WebP, HEIC ou HEIF.",
    "title": "Titre de l'événement",
    "description": "Description de l'événement",
    "venueOrganizer": "Lieu / organisateur",
    "lineup": "Programmation/hôtes (séparés par des virgules)",
    "websiteUrl": "URL du site Web",
    "instagramUrl": "URL Instagram",
    "sourceUrl": "URL de la page événement/source",
    "location": "Localisation",
    "locationHelp": "Rechercher un lieu ou une adresse. Choisissez parmi les suggestions pour épingler votre événement sur la carte.",
    "city": "Ville",
    "cityHelp": "Les événements s'affichent uniquement à l'intérieur de la ville sélectionnée.",
    "dateRange": "Plage de dates",
    "dateRangeHelp": "Définissez la date et la fenêtre horaire de l'événement public.",
    "dateFrom": "Date de",
    "dateTo": "Date du",
    "timeFrom": "Heure de",
    "timeTo": "Il est temps de",
    "lastEntry": "Heure de la dernière entrée",
    "lastEntryHelp": "Masquer cet événement en cours après cette heure, même s'il se termine plus tard.",
    "eventTags": "Balises d'événement",
    "tagsHelp": "Sélectionnez toutes les réponses pertinentes · au moins une est requise",
    "maxParticipants": "Nombre maximum de participants",
    "maxParticipantsHelp": "Entrez 0 pour un nombre illimité de participants.",
    "maxParticipantsPlaceholder": "Nombre maximum de participants",
    "freeEvent": "Événement gratuit",
    "freeEventHelp": "Tous les événements sont gratuits dans la version actuelle de Tonyte.",
    "saveTemplate": "Enregistrer comme modèle",
    "saveTemplateHelp": "Conservez cette publication d'événement complète pour de futurs téléchargements.",
    "saveCurrentTemplate": "Enregistrer les champs actuels comme modèle",
    "recurring": "Événement récurrent",
    "recurringHelp": "Utilisez les champs du modèle et créez plusieurs instances d'événement.",
    "oneTime": "Événement ponctuel",
    "weekly": "Hebdomadaire",
    "custom": "Personnalisé",
    "repeatEvery": "Répéter tous les",
    "until": "Jusqu'à",
    "occurrences": "Occurrences",
    "customDates": "Dates d'événements personnalisés",
    "customDatesHelp": "Dates séparées par des virgules, par ex. 2026-06-15, 2026-06-22",
    "skipDates": "Ignorer les dates",
    "skipDatesHelp": "Dates séparées par des virgules à ignorer.",
    "saveEvent": "Enregistrer l'événement",
    "publishRepost": "Publier la republication",
    "publishEvent": "Publier l'événement",
    "selectCity": "Sélectionnez la ville",
    "locationRequired": "Emplacement requis",
    "locationRequiredBody": "Veuillez rechercher et sélectionner un emplacement parmi les suggestions afin que votre événement puisse apparaître sur la carte.",
    "ok": "OK",
    "hashtags": "Hashtags",
    "selected": "sélectionné",
    "addHashtags": "Ajouter des hashtags",
    "collapseHashtags": "Réduire les hashtags",
    "hashtagsHelp": "Recherchez ou ajoutez des hashtags d'événements. Séparez plusieurs hashtags par des virgules."
  },
  "venueProfiles": {
    "open": "Ouvrir",
    "mapUnavailable": "Carte indisponible",
    "noAddress": "Ce lieu n'inclut pas encore d'adresse.",
    "mapOpenFailed": "Impossible d'ouvrir la carte",
    "followers": "Abonnés",
    "posts": "Messages",
    "events": "Événements",
    "upcoming": "À venir",
    "past": "Passé",
    "about": "À propos",
    "calendar": "Calendrier",
    "noEventsOnDay": "Aucun événement ce jour-là.",
    "yourVenue": "Votre profil",
    "editProfile": "Modifier le profil",
    "editLoadFailed": "Impossible de charger votre profil",
    "editSaveFailed": "Impossible d\u2019enregistrer vos modifications",
    "editNotAllowed": "Seul le propriétaire peut modifier ce profil.",
    "coverPhoto": "Photo de couverture",
    "profilePhoto": "Photo de profil",
    "changePhoto": "Changer",
    "coverHint": "Faites glisser pour déplacer, pincez ou utilisez le curseur pour zoomer. Il s\u2019affiche exactement ainsi sur votre profil et dans Vibe at Venues.",
    "adjustPhoto": "Ajuster",
    "bioLabel": "Bio",
    "bioPlaceholder": "Présentez votre lieu",
    "categoryLabel": "Catégorie",
    "dashboard": "Tableau de bord",
    "analytics": "Statistiques",
    "calendarImports": "Imports de calendrier",
    "unavailable": "Ce profil n\u2019est pas disponible.",
    "calendarImportsSub": "Vérifiez et publiez vos événements importés",
    "dashboardSub": "Clics, intérêts, partages et performance des événements",
    "follow": "Suivre",
    "following": "Suivant",
    "organizerNotFound": "Organiseur introuvable",
    "organizerUnavailable": "Ce profil d'organisateur n'est pas encore disponible.",
    "vibesTitle": "Vibe sur les sites",
    "vibesSubtitle": "Trouvez les endroits où votre peuple se rassemble.",
    "search": "Rechercher des lieux, clubs, cafés, bars...",
    "refreshFailed": "Impossible d'actualiser les publications du lieu. Montrer ce qui est disponible.",
    "noVenues": "Aucun lieu trouvé",
    "noVenuesSub": "Essayez une autre recherche ou catégorie.",
    "signInFollowVenue": "Connectez-vous avant de suivre les lieux.",
    "signInFollowOrganizer": "Connectez-vous avant de suivre les organisateurs.",
    "signInLike": "Connectez-vous avant d'aimer les publications du lieu.",
    "signInComment": "Connectez-vous avant de commenter les publications du lieu.",
    "signInDeleteComment": "Connectez-vous avant de supprimer les commentaires.",
    "notAllowed": "Non autorisé",
    "ownCommentsOnly": "Vous pouvez supprimer uniquement vos propres commentaires."
  },
  "verificationComplete": {
    "noToken": "Aucun jeton de vérification trouvé. Veuillez utiliser le lien de votre e-mail.",
    "couldNotComplete": "La vérification n'a pas pu être terminée.",
    "expiredBody": "Ce lien a expiré. Veuillez demander un nouvel e-mail de vérification dans l'application.",
    "invalidBody": "Ce lien de vérification n'est pas valide ou a déjà été utilisé.",
    "verifying": "Vérification…",
    "verified": "Adresse e-mail de l'étudiant vérifiée",
    "underReview": "En cours de révision",
    "expired": "Lien expiré",
    "invalid": "Lien invalide",
    "failed": "Échec de la vérification",
    "checking": "Vérification de la vérification de votre courrier électronique d'étudiant…",
    "verifiedUniversity": "Adresse e-mail de l'étudiant vérifiée. Bienvenue à StudiZone. Votre statut d'étudiant {university} a été confirmé.",
    "verifiedWelcome": "Adresse e-mail de l'étudiant vérifiée. Bienvenue à StudiZone.",
    "pendingBody": "Propriété de l'e-mail confirmée. La vérification de votre étudiant est en attente d'examen.",
    "back": "Retour à Tonyte"
  },
  "permissions": {
    "locationTitle": "Utiliser votre position ?",
    "locationMessage": "Tonyte utilise votre position pour afficher les événements et les projets à proximité.",
    "notificationsTitle": "Activer les notifications ?",
    "notificationsMessage": "Tonyte utilise des notifications pour les nouveaux messages, les mises à jour de plan et les rappels d'événements.",
    "cameraTitle": "Utilisez votre appareil photo ?",
    "cameraMessage": "Tonyte utilise votre appareil photo lorsque vous choisissez de prendre des photos pour votre profil, vos événements, vos projets ou votre vérification faciale.",
    "microphoneTitle": "Utilisez votre micro ?",
    "microphoneMessage": "Tonyte a besoin d'un accès au microphone pour envoyer des notes vocales.",
    "locationLabel": "emplacement",
    "notificationsLabel": "notifications\nAppareil photo",
    "cameraLabel": "",
    "microphoneLabel": "micro",
    "disabled": "Autorisation désactivée",
    "notGranted": "Autorisation non accordée",
    "blockedBody": "Tonyte n'a pas accès à votre {permission}. Vous pouvez l'activer dans Paramètres.",
    "deniedBody": "Vous pouvez continuer sans accès {permission}. Certaines fonctionnalités peuvent être limitées."
  },
  "notifications": {
    "newJoinRequest": "Nouvelle demande d'adhésion",
    "newJoinRequestBody": "Vous avez une nouvelle demande d'adhésion.",
    "planAccepted": "Vous êtes dedans 🎉",
    "planAcceptedBody": "Vous avez été accepté(e) dans un plan.",
    "newVibeRequest": "Nouvelle demande de Vibe ✨",
    "newVibeRequestBody": "Quelqu'un veut vibrer avec vous.",
    "vibeAccepted": "C'est un Vibe ✨",
    "vibeAcceptedBody": "Votre demande de Vibe a été acceptée.",
    "eventsTitle": "Ce qui se passe à Dresde",
    "eventsBody": "De nouveaux événements vous attendent.",
    "vibePlanTitle": "Un de tes vibes a créé un plan",
    "vibePlanBody": "Touche pour voir le plan et le rejoindre.",
    "partnerUpdateTitle": "Du nouveau chez un partenaire suivi",
    "partnerUpdateBody": "Découvrez les nouveautés.",
    "newFollowerTitle": "Vous avez un nouvel abonné 🧡",
    "newFollowerBody": "Quelqu'un vient de vous suivre sur Tonyte.",
    "profilePhotoReminderTitle": "Complétez votre profil Tonyte 👋",
    "profilePhotoReminderBody": "Ajoutez une photo de profil pour débloquer les Plans et les Vibes.",
    "appUpdateReminderTitle": "Un meilleur Tonyte vous attend 🧡",
    "appUpdateReminderBody": "Mettez à jour Tonyte pour profiter des dernières fonctionnalités, corrections et améliorations."
  },
  "vibeClaim": {
    "playedOnWeb": "Tu as joué au jeu Vibe sur le web ?",
    "enterCodeTitle": "Ajoute tes réponses du web",
    "enterCodeBody": "Saisis le code affiché à la fin du jeu Vibe sur tonyte.app.",
    "continue": "Continuer",
    "ok": "OK",
    "invalidFormat": "Les codes ressemblent à ABCD-EFGH.",
    "invalidCode": "Ce code n'existe pas ou a expiré.",
    "oldRoundCode": "Ce code concernait une manche précédente, déjà terminée.",
    "alreadyClaimedCode": "Ces réponses ont déjà été ajoutées à un compte Tonyte.",
    "savedSignIn": "C'est noté ! Connecte-toi ou crée un compte et nous ajouterons tes réponses.",
    "networkError": "Impossible de vérifier le code. Vérifie ta connexion et réessaie.",
    "rateLimited": "Trop de tentatives. Patiente quelques minutes.",
    "waitingBanner": "Tes réponses Vibe du web t'attendent. Connecte-toi ou inscris-toi pour voir tes vibes.",
    "discard": "Supprimer les réponses du web",
    "addedToast": "Tes réponses du web sont enregistrées ✨",
    "unlocksAt13": "Tes premières vibes se débloquent à 13h00.",
    "alreadyPlayedTodayTitle": "Tu as joué au jeu Vibe du jour",
    "alreadyPlayedTodayBody": "Tes réponses du jour sont déjà enregistrées. Chaque compte joue une fois par jour, donc un code du web ne peut pas s'y ajouter. Une nouvelle manche commence demain à 6 h.",
    "addingTitle": "Ajout de tes réponses du web…",
    "addingBody": "Nous ajoutons les réponses du code que tu as saisi. Ça ne prend qu'un instant.",
    "notOpenTitle": "Le jeu du jour n'est pas encore ouvert",
    "notOpenBody": "Le jeu Vibe ouvre à 6 h. Les codes ne fonctionnent que le jour où tu as joué.",
    "seeMyVibes": "Voir mes vibes",
    "alreadyPlayedTitle": "Tu as déjà joué aujourd'hui",
    "alreadyPlayedBody": "Tu avais déjà répondu aux questions Vibe du jour dans l'app, nous les avons donc gardées. Les réponses sont verrouillées une fois envoyées : celles du web n'ont pas été utilisées.",
    "roundClosedTitle": "Ces réponses étaient pour le {date}",
    "roundClosedBody": "Les réponses du web ne comptent que pour la manche où elles ont été jouées, et cette manche est terminée. Les questions du jour t'attendent dans Day Vibes.",
    "playToday": "Jouer aujourd'hui",
    "claimedElsewhereTitle": "Déjà sur un autre compte",
    "claimedElsewhereBody": "Ces réponses ont été ajoutées à un autre compte Tonyte. Chaque ensemble de réponses ne peut appartenir qu'à un seul compte.",
    "notFoundTitle": "Impossible d'ajouter ces réponses",
    "notFoundBody": "Le lien ou le code a expiré ou n'est pas valide. Les réponses du web peuvent être ajoutées jusqu'à minuit (heure de Berlin) le jour où tu as joué.",
    "notEligibleBody": "Day Vibes n'est pas disponible pour ce type de compte.",
    "emailFoundTitle": "Ajouter tes réponses du web ?",
    "emailFoundBody": "Tu as enregistré les réponses Vibe du jour sur tonyte.app avec {email}. Les ajouter à ce compte ?",
    "addAnswers": "Ajouter",
    "notNow": "Pas maintenant"
  },
  partnerCommunity: {
    button: 'Community chat',
    followToJoinTitle: 'Follow to join?',
    followToJoinBody: 'Follow {name} to join their community chat.',
    followAndJoin: 'Follow & join',
    signIn: 'Sign in to join this partner’s community. You’ll return here afterward.',
    signInAction: 'Sign in',
    joinFailed: 'Couldn’t join the community. Please try again.',
    unfollowTitle: 'Unfollow and leave community?',
    unfollowBody: 'Unfollowing {name} also removes you from their community chat.',
    unfollowAndLeave: 'Unfollow & leave',
    messagesTab: 'Messages',
    notificationsTab: 'Notifications',
    communitiesTab: 'Community Chats',
    incoming: 'Incoming requests',
    outgoing: 'Outgoing requests',
    emptyTitle: 'Find your communities',
    emptyBody: 'Follow a partner and join their community to chat with people around it.',
    discover: 'Discover partners',
    about: 'The official member chat for this partner.',
    memberOnly: 'Followers’ community',
    leaveConfirm: 'Leave this community chat? You will keep following the partner.',
    ownerCannotLeave: 'You administer this community as the partner owner.',
    accessRemoved: 'You no longer have access to this community.',
    allowBack: 'Allow back',
    allowedBack: 'This person can rejoin after following the partner.',
    rejoined: 'Member reinstated.',
    descriptionPlaceholder: 'Ajoutez une description de la communauté…',
    descriptionSaved: 'Description de la communauté mise à jour.',
    descriptionSaveFailed: 'Impossible de mettre à jour la description.',
    admin: 'Admin',
    coAdmin: 'Co-admin',
    makeCoAdmin: 'Nommer co-admin',
    removeCoAdmin: 'Retirer le rôle de co-admin',
    coAdminAdded: '{name} est maintenant co-admin.',
    coAdminRemoved: '{name} n’est plus co-admin.',
  },
  "partnerReviews": {
    "tab": "Avis",
    "reviewCount_one": "{count} avis",
    "reviewCount_other": "{count} avis",
    "ratingCount_one": "{count} note",
    "ratingCount_other": "{count} notes",
    "starCount_one": "{count} étoile",
    "starCount_other": "{count} étoiles",
    "noReviewsYet": "Pas encore d’avis",
    "beFirst": "Écrivez le premier",
    "summaryA11y": "Noté {avg} sur 5 d’après {count} avis. Voir les avis",
    "write": "Écrire un avis",
    "edit": "Modifier votre avis",
    "ownProfile": "Les avis viennent des visiteurs : vous ne pouvez pas noter votre propre profil.",
    "signInToReview": "Connectez-vous ou créez un compte pour écrire un avis.",
    "filterAll": "Tous",
    "empty": "Pas encore d’avis",
    "emptySub": "Vous y êtes allé ? Racontez comment c’était et aidez les autres à choisir.",
    "emptyFiltered": "Pas encore d’avis à {count} étoiles.",
    "loadFailed": "Impossible de charger les avis.",
    "retry": "Réessayer",
    "showMore": "Voir plus d’avis",
    "edited": "Modifié",
    "readMore": "Lire la suite",
    "showLess": "Voir moins",
    "yourReview": "Votre avis",
    "hiddenNotice": "Vous seul voyez cet avis pendant que notre équipe le vérifie.",
    "removedNotice": "Notre équipe de modération a retiré cet avis. Vous pouvez le supprimer et en écrire un nouveau.",
    "menu": "Options de l’avis",
    "titleNew": "Noter {name}",
    "titleEdit": "Modifier votre avis",
    "aboutPartner": "Vous notez {name} dans son ensemble, pas un seul événement.",
    "draftRestored": "Nous avons gardé votre avis inachevé.",
    "ratingLabel": "Votre note",
    "tapToRate": "Touchez une étoile pour noter",
    "ratingRequired": "Choisissez une note en étoiles pour continuer.",
    "textLabel": "Votre avis (facultatif)",
    "placeholder": "C’était comment ? Ambiance, personnes, événements…",
    "submit": "Publier l’avis",
    "update": "Enregistrer",
    "posted": "Merci pour votre avis !",
    "updated": "Avis mis à jour",
    "deleted": "Avis supprimé",
    "deleteTitle": "Supprimer votre avis ?",
    "deleteBody": "Votre note et votre texte seront retirés de {name}.",
    "ratingWords": {
      "1": "Pas pour moi",
      "2": "Peut mieux faire",
      "3": "Correct",
      "4": "Très bien",
      "5": "Adoré"
    },
    "actions": {
      "edit": "Modifier l’avis",
      "delete": "Supprimer l’avis",
      "report": "Signaler l’avis",
      "hide": "Masquer l’avis (admin)",
      "restore": "Rétablir l’avis (admin)",
      "remove": "Retirer l’avis (admin)",
      "dismiss": "Classer les signalements"
    },
    "confirm": {
      "hideTitle": "Masquer cet avis ?",
      "hideBody": "Il disparaît du profil et ne compte plus dans la note jusqu’à son rétablissement.",
      "removeTitle": "Retirer cet avis ?",
      "removeBody": "Le texte est effacé et il ne compte plus dans la note. Action irréversible.",
      "dismissTitle": "Classer ces signalements ?",
      "dismissBody": "L’avis reste visible et les signalements sont fermés."
    },
    "moderated": {
      "hide": "Avis masqué",
      "restore": "Avis rétabli",
      "remove": "Avis retiré",
      "dismiss": "Signalements classés"
    },
    "reportTitle": "Signaler cet avis",
    "reportReason": "Pourquoi le signalez-vous ?",
    "reasons": {
      "spam": "Spam ou publicité",
      "harassment": "Harcèlement ou haine",
      "inappropriate": "Contenu inapproprié",
      "fake": "Faux ou trompeur",
      "other": "Autre chose"
    },
    "reportDetails": "Autre chose à nous dire ? (facultatif)",
    "reportSubmit": "Envoyer le signalement",
    "reported": "Merci, notre équipe va vérifier.",
    "errors": {
      "signIn": "Reconnectez-vous pour publier votre avis. Votre brouillon est enregistré.",
      "verifyEmail": "Vérifiez votre e-mail pour publier des avis. Votre brouillon est enregistré.",
      "ownProfile": "Vous ne pouvez pas noter votre propre profil.",
      "removed": "Cet avis a été retiré par la modération et ne peut pas être modifié.",
      "rating": "Choisissez une note de 1 à 5 étoiles.",
      "tooLong": "Les avis peuvent contenir au maximum 1 000 caractères.",
      "unavailable": "Ce profil n’est pas disponible.",
      "reviewGone": "Cet avis n’est plus disponible.",
      "ownReview": "Vous ne pouvez pas signaler votre propre avis.",
      "access": "Votre compte ne peut pas publier d’avis pour le moment.",
      "network": "Problème de connexion, réessayez. Votre brouillon est enregistré.",
      "generic": "Une erreur s’est produite. Réessayez."
    },
    "admin": {
      "title": "Avis signalés",
      "profileSub": "Masquer ou retirer les avis de partenaires signalés",
      "open": "Ouverts",
      "resolved": "Traités",
      "empty": "Aucun avis signalé.",
      "reason": "Motif",
      "details": "Détails",
      "reportedAt": "Signalé le {date}",
      "currentStatus": "Actuellement",
      "status": {
        "published": "Visible",
        "hidden": "Masqué",
        "removed": "Retiré",
        "missing": "Supprimé"
      },
      "resolution": {
        "hidden": "Masqué",
        "removed": "Retiré",
        "dismissed": "Classé",
        "review_deleted": "Supprimé par l’auteur",
        "restored": "Rétabli"
      },
      "openProfile": "Ouvrir le profil",
      "loadFailed": "Impossible de charger les signalements."
    }
  }
};
